<script setup>
import { computed, onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiEye, mdiTrashCan, mdiPencil, mdiCheckDecagram, mdiCalendarClock, mdiBook, mdiContentSave, mdiPlusBox, mdiBookOpenVariant, mdiCurrencyUsd, mdiPlus,
    mdiInformationOutline, mdiPlusCircle, mdiChevronLeft, mdiChevronRight, mdiAccountVoice, mdiGoogleClassroom,
    mdiDownload, mdiArrowUpCircle, mdiArrowDownCircle, mdiAccountGroup, mdiNoteText, mdiHandWave, mdiArrowLeftTopBold,
    mdiCheckBold, mdiExclamationThick, mdiCloseThick, mdiAccountBox, mdiCloseCircle, mdiCheckCircle, mdiRefresh, mdiContrastCircle, mdiAlertCircle, mdiMenu, mdiPaperclip, mdiAccountSchool
} from "@mdi/js";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeLabel from '@/Components/Label.vue';
import BreezeInput from '@/Components/Input.vue';
import { QuillEditor } from '@vueup/vue-quill'
//import BlotFormatter from 'quill-blot-formatter'
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
//import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import NotificationBar from "@/Components/NotificationBar.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import BreezeButton from '@/Components/Button.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
//import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
import CompetencyGraphic from "@/Components/CompetencyGraphic.vue";
import { Icon } from '@iconify/vue';

// LRR
const props = defineProps({
    titleup: String,
    classroom: Object,
    course: Object,
    guides: Array,
    students: Array,
    studentCol: Array,
    diarios: Array,
    conductas: Array,
    nowDate: String,
    nowDay: String,
    nowDayLetter: String,
    //message: String,
    competencias: Array,
    // deprecated evolucion_informes: Array,
    refresh_screen_operation_inertia: Array,
    refCicloActual: String,
    semanaActual: Number,
    bimestreActual: String,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    anioEscolar: String,
    back_link: String,
    closeB1: Boolean,
    closeB2: Boolean,
    closeB3: Boolean,
    closeB4: Boolean,
    isPsico: Boolean,
    isSecre: Boolean,
    puntajeMaximo: String,
    puntajeMinimo: String,
    informeEvoInicial: String,
    canWriteInforme: Boolean,
    ciclo_curricular: String,
    arrayDeudores: Array,
    arrayDeudoresCol: Array
});

//const message = computed(() => usePage().props.value.flash.message).value
//const success= ref(true)
//const message = usePage().props.value.flash.message
//console.log(message)

// Editar tamaño de imagen en QuillEditor
//const modulesEditor = {
//name: 'blotFormatter',  
//module: BlotFormatter, 
//options: {/* options */}
//}

const data = {
    "estudiante_curso": [
        { "id": 1, "codigo": "2205-ARTE", "name": "ARTE", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 2, "codigo": "2205-BIOLO", "name": "BIOLOGIA", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "última fecha de entrega de trabajos este viernes ..." },
        { "id": 3, "codigo": "2205-FISICA", "name": "FISICA", "tarea": "2/2 (FL 12/10/2022)", "anuncio": "Entrega de trabajo grupal hasta el martes" },
        { "id": 4, "codigo": "2205-QUIMICA", "name": "QUIMICA", "tarea": "4/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 5, "codigo": "2205-HISTO", "name": "HISTORIA DEL PERU", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
    ]
};

let myRadios = document.getElementsByName('tabs2');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}

/* const filesForLevel = ref([])
onMounted(() => {
    let url = '/file/listfilesforlevel';
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        filesForLevel.value = respuesta.files;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    });
}); */
const showLog = ref(false);
const responseMsg = ref(null);
const arrayCalifications = ref([])
const arrayAdmisionPuntajes = ref([])
const taskResponses = ref([])
onMounted(() => {
    listarPostit()
    listarStudent(props.classroom.id)
    arrayConductas.value = props.conductas
    arrayDiarios.value = props.diarios
    fetchSchedule()
    fetchDailyAgenda(agendaDate.value)
    //listarAdmisionPuntaje(props.refCicloActual)
    //listarCalification(props.classroom.id, props.refCicloActual)
    //listarCalification(props.refCicloActual)
    //listarTaskResponses()// <-- Por defecto id_task = 0
    //console.log(taskResponses.value)
});

// --- HORARIO DE CURSOS Y AGENDA ESCOLAR ---
const scheduleCourses = ref([]);
const scheduleList = ref([]);
const loadingSchedule = ref(false);
const isScheduleModalOpen = ref(false);
const scheduleForm = ref({
    day_of_week: 1,
    start_time: '08:00',
    end_time: '08:45',
    type: 'clase',
    id_course: null,
    label_break: 'Recreo',
});

const daysOfWeekList = [
    { id: 1, label: 'Lunes' },
    { id: 2, label: 'Martes' },
    { id: 3, label: 'Miércoles' },
    { id: 4, label: 'Jueves' },
    { id: 5, label: 'Viernes' },
];

const fetchSchedule = () => {
    loadingSchedule.value = true;
    axios.get(route('classroom.schedule.get', { id_classroom: props.classroom.id }))
        .then(response => {
            if (response.data.success) {
                scheduleCourses.value = response.data.courses;
                scheduleList.value = response.data.schedules;
                if (!scheduleForm.value.id_course && scheduleCourses.value.length > 0) {
                    scheduleForm.value.id_course = scheduleCourses.value[0].id;
                }
            }
        })
        .catch(err => console.error(err))
        .finally(() => { loadingSchedule.value = false; });
};

const addScheduleItem = () => {
    if (!scheduleForm.value.start_time || !scheduleForm.value.end_time) {
        showAlert('Ingresa la hora de inicio y fin', 'warning');
        return;
    }
    const courseObj = scheduleCourses.value.find(c => c.id === scheduleForm.value.id_course);
    scheduleList.value.push({
        id: null,
        day_of_week: Number(scheduleForm.value.day_of_week),
        start_time: scheduleForm.value.start_time,
        end_time: scheduleForm.value.end_time,
        type: scheduleForm.value.type,
        id_course: scheduleForm.value.type === 'clase' ? scheduleForm.value.id_course : null,
        label_break: scheduleForm.value.type === 'recreo' ? (scheduleForm.value.label_break || 'Recreo') : null,
        course: scheduleForm.value.type === 'clase' ? courseObj : null,
        sort_order: scheduleList.value.length + 1
    });
    scheduleList.value.sort((a, b) => a.day_of_week - b.day_of_week || a.start_time.localeCompare(b.start_time));
};

const removeScheduleItem = (index) => {
    scheduleList.value.splice(index, 1);
};

const populateStandardSchedule = () => {
    const blocks = [
        { start: '08:00', end: '08:45', type: 'clase' },
        { start: '08:45', end: '09:30', type: 'clase' },
        { start: '09:30', end: '10:00', type: 'recreo', label: 'Recreo' },
        { start: '10:00', end: '10:45', type: 'clase' },
        { start: '10:45', end: '11:30', type: 'clase' },
        { start: '11:30', end: '12:00', type: 'recreo', label: 'Recreo / Almuerzo' },
        { start: '12:00', end: '12:45', type: 'clase' },
        { start: '12:45', end: '13:30', type: 'clase' },
    ];
    const currentDay = Number(scheduleForm.value.day_of_week);
    blocks.forEach((b, idx) => {
        scheduleList.value.push({
            id: null,
            day_of_week: currentDay,
            start_time: b.start,
            end_time: b.end,
            type: b.type,
            id_course: b.type === 'clase' && scheduleCourses.value[idx % (scheduleCourses.value.length || 1)] ? scheduleCourses.value[idx % scheduleCourses.value.length].id : null,
            label_break: b.type === 'recreo' ? b.label : null,
            course: b.type === 'clase' && scheduleCourses.value[idx % (scheduleCourses.value.length || 1)] ? scheduleCourses.value[idx % scheduleCourses.value.length] : null,
            sort_order: scheduleList.value.length + 1
        });
    });
    scheduleList.value.sort((a, b) => a.day_of_week - b.day_of_week || a.start_time.localeCompare(b.start_time));
};

const saveScheduleToServer = () => {
    loadingSchedule.value = true;
    axios.post(route('classroom.schedule.save'), {
        id_classroom: props.classroom.id,
        items: scheduleList.value
    }).then(response => {
        if (response.data.success) {
            showAlert('Horario guardado exitosamente', 'success');
            isScheduleModalOpen.value = false;
            fetchSchedule();
        }
    }).catch(err => {
        showAlert('Error al guardar horario', 'danger');
    }).finally(() => {
        loadingSchedule.value = false;
    });
};

// --- AGENDA DIARIA ---
const getLocalDateString = (d = new Date()) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const agendaDate = ref(props.nowDate || getLocalDateString());
const agendaHeader = ref({
    date: props.nowDate,
    dayNumber: props.nowDay || '01',
    dayName: props.nowDayLetter || 'Hoy',
    monthName: 'Mes',
    weekNumber: props.semanaActual || 1,
    year: props.anioEscolar || '2026'
});
const agendaRows = ref([]);
const agendaStudents = ref([]);
const agendaStudentRecords = ref([]);
const agendaDiarios = ref([]);
const loadingAgenda = ref(false);
const savingAgenda = ref(false);

const fetchDailyAgenda = (targetDate) => {
    loadingAgenda.value = true;
    const dt = targetDate || agendaDate.value;
    axios.get(route('classroom.agenda.daily'), {
        params: {
            id_classroom: props.classroom.id,
            date: dt
        }
    }).then(response => {
        if (response.data.success) {
            agendaHeader.value = response.data.header;
            agendaRows.value = response.data.agendaItems;
            agendaStudents.value = response.data.students;
            agendaStudentRecords.value = response.data.studentRecords;
            agendaDiarios.value = response.data.diarios;
        }
    }).catch(err => {
        console.error(err);
    }).finally(() => {
        loadingAgenda.value = false;
    });
};

const changeAgendaDate = (deltaDays) => {
    const [y, m, d] = (agendaDate.value || getLocalDateString()).split('-').map(Number);
    const current = new Date(y, m - 1, d);
    current.setDate(current.getDate() + deltaDays);
    const newDateStr = getLocalDateString(current);
    agendaDate.value = newDateStr;
    fetchDailyAgenda(newDateStr);
};

const onAgendaDateChange = (event) => {
    const val = event.target.value;
    if (val) {
        agendaDate.value = val;
        fetchDailyAgenda(val);
    }
};

const addAgendaRow = () => {
    agendaRows.value.push({
        id: null,
        id_course: null,
        course_name: '',
        day_order: agendaRows.value.length + 1,
        topic: '',
        has_homework: false,
        homework: ''
    });
};

const removeAgendaRow = (index) => {
    agendaRows.value.splice(index, 1);
};

const saveDailyAgendaToServer = () => {
    savingAgenda.value = true;
    axios.post(route('classroom.agenda.daily.save'), {
        id_classroom: props.classroom.id,
        date: agendaDate.value,
        week_number: agendaHeader.value.weekNumber,
        items: agendaRows.value
    }).then(response => {
        if (response.data.success) {
            showAlert('Agenda diaria guardada con éxito', 'success');
            fetchDailyAgenda(agendaDate.value);
        }
    }).catch(err => {
        showAlert('Error al guardar la agenda', 'danger');
    }).finally(() => {
        savingAgenda.value = false;
    });
};

const getStudentAttendanceLabel = (studentId) => {
    const d = agendaDiarios.value.find(diar => diar.id_student === studentId);
    if (!d) return { text: 'PENDIENTE', color: 'bg-slate-100 text-slate-500 border-slate-200' };
    if (d.asistencia == 1) return { text: 'ASISTIÓ', color: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30' };
    if (d.asistencia == 0) return { text: 'FALTA', color: 'bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/30' };
    if (d.asistencia == 2) return { text: 'TARDANZA', color: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30' };
    if (d.asistencia == 3) return { text: 'FALTA JUST.', color: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/30' };
    return { text: 'TARDANZA JUST.', color: 'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border-indigo-500/30' };
};

const getStudentRecordsForDay = (studentId) => {
    return agendaStudentRecords.value.filter(r => r.id_student === studentId);
};

// NOta postit
const arrayPostit = ref([]);
const postitDescription = ref('');
const listarPostit = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/postit/listar?type_object=collaborator_classroom&fk_object=' + props.classroom.id + '&fk_object2=0';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayPostit.value = respuesta.data;
        console.log(arrayPostit.value);
    }).catch(function (error) {
        console.log(error);
    });
}
const updateOrCreatePostit = (id = 0, content = '') => {
    let ruta = 'postit-actualizar'
    let title = 'Bloc de Notas'
    if (id > 0) {
        axios.put(route(ruta), {
            'id': id,
            'description': content
        }).then(function (response) {
            //showAlert('Registro actualizado', 'success')
            showAlertPostit('Nota Actualizada')
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
            if (error.response.status == 419) {
                let alertConfirm = confirm('Se requiere actualizar por tiempo de inactividad ...')
                if (alertConfirm) {
                    window.location.href = 'login';
                }
            }
        });
    } else {
        ruta = 'postit-registrar'
        axios.post(route(ruta), {
            'type_object': 'collaborator_classroom',
            'fk_object': props.classroom.id,
            'fk_object2': 0,
            'label': title,
            'description': content
        }).then(function (response) {
            //showAlert('Registro Creado', 'success')
            showAlertPostit('Nota creada')
            listarPostit()
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
        });
    }
}

const alertPostit = ref('');
const showAlertPostit = (text = '', time = 2) => {
    alertPostit.value = text

    setTimeout(() => {
        alertPostit.value = ''
    }, time * 1000)// LRR bind(this)
}

// Estudiantes
const arrayStudents = ref([]);
const arrayStudentCol = ref([]);
const arrayEAPs = ref([]);
const listarStudent = (id_classroom) => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/students/classroom' + '?id_classroom=' + id_classroom;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayStudents.value = respuesta.datalist;
        arrayStudentCol.value = respuesta.columnas;
        arrayEAPs.value = respuesta.select1;
        console.log(arrayStudents.value);
        //console.log(arrayEAPs.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const arrayCalification = ref([]);
const arrayCalificationCol = ref([]);
const arrayCalificationConsolidado = ref([]);
const listarCalification = (id_classroom, refCiclo = '', consolidado = '') => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/califications/classroom' + '?id_classroom=' + id_classroom + '&ref_ciclo=' + refCiclo;
    if (consolidado) url = '/califications/consolidado' + '?id_classroom=' + id_classroom;
    axios.get(url).then((response) => {
        let respuesta = response.data;
        if (consolidado) {
            arrayCalificationConsolidado.value = respuesta.datalist;
            console.log(arrayCalificationConsolidado.value);
        } else {
            arrayCalification.value = respuesta.datalist;
            console.log(arrayCalification.value);
        }
        arrayCalificationCol.value = respuesta.columnas;
        //arrayEAPs.value = respuesta.select1;
        //console.log(arrayEAPs.value);
    }).catch((error) => {
        console.log(error);
    });
}


const listarCalificationConsolidado = async (id_classroom, anioescolar = '') => {
    let consolidado = []
    let columnas = []
    const getCalification = (id_classroom, refCiclo = '') => {
        let url = '/califications/classroom' + '?id_classroom=' + id_classroom + '&ref_ciclo=' + refCiclo;
        //if (consolidado) url = '/califications/consolidado'+'?id_classroom='+id_classroom;
        axios.get(url).then((response) => {
            let respuesta = response.data;
            columnas = respuesta.columnas;
            console.log(respuesta.datalist);
            return respuesta.datalist;
        }).catch((error) => {
            console.log(error);
        });
    }

    for (let ic = 1; ic < 5; ic++) {
        let califBimestre = []
        califBimestre = getCalification(id_classroom, anioescolar + 'B' + ic)
        consolidado.push(califBimestre)
        console.log(consolidado);
    }

    /* await listarCalification(id_classroom, anioescolar+'B1')
    arrayCalificationConsolidado.value = arrayCalification.value
    await listarCalification(id_classroom, anioescolar+'B2')
    //let array2 = arrayCalification.value
    arrayCalificationConsolidado.value.concat(arrayCalification.value)
    await listarCalification(id_classroom, anioescolar+'B3')
    let array3 = arrayCalification.value
    await listarCalification(id_classroom, anioescolar+'B4')
    let array4 = arrayCalification.value */

    //if (array1) arrayCalificationConsolidado.value = array1
    //if (array2) arrayCalificationConsolidado.value =  [].concat(array2)
    //arrayCalificationConsolidado.value.unshift(array2)
    console.log(JSON.stringify(consolidado))

}

// Sección Admisión puntajes
const listarAdmisionPuntaje = (ref_ciclo) => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/admisionpuntaje/aula' + '?id_classroom=' + props.classroom.id + '&ref_ciclo=' + ref_ciclo;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayAdmisionPuntajes.value = respuesta;
        //console.log(arrayCalifications.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const formAdmisionPuntaje = useForm({
    id_student: 0,
    ref_ciclo: '',
    puntaje: null,
    resultado: '2',// Ausente, 0 desaprobado y 1 aprobado
    status: 0

});

const iniciarAdmisionPuntaje = (ref_ciclo) => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
      } */

    const newArr = [];
    const arr = props.students
    arr.forEach((student) => {
        newArr.push({
            id_student: student.id,
            puntaje: formAdmisionPuntaje.puntaje,
            resultado: formAdmisionPuntaje.resultado,
            status: 0
        });
    });
    let ruta = 'admisionpuntaje-registrar'
    if (newArr.length) {
        axios.post(route(ruta), {
            'ref_ciclo': ref_ciclo,
            'arrayData': newArr,

        }).then(function (response) {
            listarAdmisionPuntaje(ref_ciclo)
            showAlert('Se inició Adminición puntaje del ' + ref_ciclo, 'success', 3)
            //console.log('Registro actualizado');
            console.log(newArr)
        }).catch(function (error) {
            console.log(error);
        });

    }
    //return newArr;

}

const updateAdmisionPuntaje = (id, action, data = []) => {
    let ruta = 'admisionpuntaje-' + action
    if (id > 0) {

        if (action == 'actualizar') {
            //countAction++
            //alertIndex.value = 
            axios.put(route(ruta), {
                'id': id,
                'puntaje': data['puntaje'],
                'resultado': data['resultado'],
            }).then((response) => {
                countAction++
                countActionOk++

                if (!guardarTodo) {
                    showAlert(countAction + ' registro actualizado', 'success')
                    countAction = 0
                    countActionOk = 0
                } else {
                    if (countAction == 1) {
                        showAlert('Validando, espere por favor ...', 'warning', 3)
                    }

                    if (arrayAdmisionPuntajes.value && arrayAdmisionPuntajes.value.length == countAction) {
                        showAlert(countActionOk + ' registros actualizados', 'success', 3)
                        countAction = 0
                        countActionOk = 0
                        guardarTodo = 0
                    }
                }

                //console.log(countAction+' registro actualizado');
            }).catch((error) => {
                console.log(error);
                errors.value = 1
                countAction++

                showAlert(countAction + ' registro con error', 'danger', 10)
                if (!guardarTodo) {
                    countAction = 0
                } else {
                    if (arrayAdmisionPuntajes.value && arrayAdmisionPuntajes.value.length == countAction) {
                        countAction = 0
                        countActionOk = 0
                        guardarTodo = 0
                    }
                }
            });

        } else {
            axios.put(route(ruta), {
                'id': id,
            }).then(function (response) {
                showAlert('Estado actualizado', 'success')

                // Lista dependiendo en que tab está
                if (tabPuntaje.value == 0) {
                    console.log('Primer bimestre')
                    listarAdmisionPuntaje(props.anioEscolar + 'B1')
                } else if (tabPuntaje.value == 1) {
                    console.log('Segundo bimestre')
                    listarAdmisionPuntaje(props.anioEscolar + 'B2')
                } else if (tabPuntaje.value == 2) {
                    console.log('Tercer bimestre')
                    listarAdmisionPuntaje(props.anioEscolar + 'B3')
                } else if (tabPuntaje.value == 3) {
                    console.log('Cuarto bimestre')
                    listarAdmisionPuntaje(props.anioEscolar + 'B4')
                }

                console.log('Año escolar: ' + props.anioEscolar);
            }).catch(function (error) {
                console.log(error);
            });
            //listarCalification()
            //Inertia.reload({ only: ['message']})
            console.log('Año escolar: ' + props.anioEscolar);
        }

    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}

const isActionMassive = ref(false)
const updateArrayAdmisionPuntajes = (bimestre = '') => {
    isActionMassive.value = true
    guardarTodo = 1
    let buttons = document.getElementsByName('buttonssave' + bimestre);
    //let count = 0
    //let lastIt = buttons.length - 1
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].click();
    }
}

const updateArrayConductas = () => {
    isActionMassive.value = true
    guardarTodo = 1
    let buttons = document.getElementsByName('buttonssave-conducta');
    //let count = 0
    //let lastIt = buttons.length - 1
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].click();
    }
}

/* const refreshStudents = () => {
    arrayStudents.value = props.students
    console.log('refreshStudents')
} */

const isModalActive = ref(false);
const isModalDangerActive = ref(false);
const isModalFullActive = ref(false);
const modalFullSrc = ref('');
const refCiclo = ref('')/// <------------------- Revisar
const rowID = ref('');
const rowParentID = ref('');
const rowAction = ref('');
const isErrorForm = ref(false)
const titleModal = ref('')
const sufijoTitle = ref('')

const studentPromedios = (id) => {
    rowID.value = id;
    rowAction.value = 'showPromedios'
    titleModal.value = 'Gráfica ordenado por áreas'
    listarChartCalification('', id)
    isModalActive.value = true
    console.log('emitparent ' + id)
}

const chartCalifications = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
const chartSelectCiclo = ref(null);
const listarChartCalification = (ref_ciclo = '', id_student = 0) => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/calification/grafica' + '?id=' + id_student + '&ref_ciclo=' + ref_ciclo;
    if (ref_ciclo) {
        chartCalifications.value = null // <-- Limpiar value si se vuelve a consultar y no dejarlo en array
    }
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        chartCalifications.value = respuesta.datachart;// El return directo del array trae otros datos que generan error para el chart
        chartSelectCiclo.value = respuesta.refciclo
        console.log(chartCalifications.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const mainTab = ref(0)
const tabCalif = ref(-1)// Pordefecto ya no será 0
const tabPuntaje = ref(-1)// Pordefecto ya no será 0
const tabEvoInforme = ref(-1)// Pordefecto ya no será 0
const refCicloSelect = ref('')

/* if (props.refCicloActual.indexOf('B2')) {
    tabCalif.value = 1
} else if (props.refCicloActual.filter('B3')) {
    tabCalif.value = 2;
} else if (props.refCicloActual.filter('B4')) {
    tabCalif.value = 3;
} */

const formTarea = useForm({
    id_classroom: props.classroom.id,
    id_course: props.course.id,
    ref_ciclo: props.refCicloActual,//refCiclo.value,// Se busca por ref pues son 4 2023B1, 2023B2, 2023B3, 2023B4
    label: '',
    description: '',
    end_date: null,
    status: 0,

    description_collaborator: '',
    calification: 0,
    id_task: 0
});

const existeAdjunto = ref(false)
const filePath = ref('')
const fileName = ref('')

const initModal = (id, action, data = []) => {
    isErrorForm.value = false
    rowAction.value = action
    titleModal.value = action
    if (action == 'borrador') {
        titleModal.value = 'establecer como borrador'
    } else if (action == 'leer') {
        titleModal.value = 'vista previa del'
    } else if (action == 'actualizar') {
        titleModal.value = 'Actualizar informe de '
    } else if (action == 'publicar') {
        titleModal.value = 'enviar a libreta '
    }

    if (action == 'registrar') {
        isModalActive.value = true

    } else if (action == 'actualizar') {
        rowID.value = id;
        isModalActive.value = true
        sufijoTitle.value = data['apellidos'] + ' ' + data['nombres']
        formInforme.ref_ciclo = data['ref_ciclo']
        formInforme.informe = data['informe']
        formInforme.status = data['status']


    } else if (action == 'leer') {
        rowID.value = id;
        isModalActive.value = true
        formInforme.ref_ciclo = data['ref_ciclo']
        formInforme.informe = data['informe']
        formInforme.status = data['status']

    } else {// Casos de publicar o no
        rowID.value = id;
        isModalDangerActive.value = true

    }
}

const isConfirm = () => {
    //alert('Hola '+rowID.value+'modal es '+rowAction.value)
    ///let ruta = props.ruta + '-' + rowAction.value
    let ruta = 'evolucioninforme-' + rowAction.value

    if (rowAction.value == 'registrar') {

        if (!formInforme.ref || !formInforme.description || !formInforme.end_date) {// || !form.ref 
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.post(route(ruta, {
                'id_classroom': formInforme.id_classroom,
                'id_course': formInforme.id_course,
                'ref_ciclo': formInforme.ref_ciclo,
                'label': formInforme.label,
                'description': formInforme.description,
                'end_date': formInforme.end_date
            })).then((response) => {
                console.log(response)
                cleanVal()
                listarEvolucionInforme(tabRefCiclo.value)
                if (!props.debugInertia) Inertia.reload({ only: ['refresh_screen_operation_inertia'] })
            }).catch((error) => {
                console.log(error)
            })
            /* Inertia.post(route(ruta, {
                'id_classroom' : formInforme.id_classroom,
                'id_course' : formInforme.id_course,
                'ref_ciclo' : formInforme.ref_ciclo,
                'label' : formInforme.label,
                'description' : formInforme.description,
                'end_date' : formInforme.end_date
            }
            )) */
            //cleanVal()
            //Inertia.reload({ only: ['evolucion_informes']})
            //listarEvolucionInforme(tabRefCiclo.value)
            //Inertia.reload({ only: ['refresh_screen_operation_inertia']})// para que no aparesca la pantalla
            //Inertia.reload({ only: ['tasks'], preserveState: true})
            //Inertia.reload({ only: ['tasks']})
        }

    } else if (rowAction.value == 'actualizar') {

        if (!formInforme.ref_ciclo || !formInforme.informe) {
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.put(route(ruta, {
                'id': rowID.value,
                'ref_ciclo': formInforme.ref_ciclo,
                'informe': formInforme.informe
            })).then((response) => {
                console.log('Informe actualizado')
                cleanVal()
                listarEvolucionInforme(tabRefCiclo.value)
                if (!props.debugInertia) Inertia.reload({ only: ['refresh_screen_operation_inertia'] })// para que no aparesca la pantalla
            }).catch((error) => { console.log(error) })
            /* Inertia.put(route(ruta, {
                'id' : rowID.value,
                'ref_ciclo' : formInforme.ref_ciclo,
                'informe' : formInforme.informe
            }
            )) */
            //console.log('Informe actualizado')
            //cleanVal()
            //Inertia.reload({ only: ['evolucion_informes']})
            //listarEvolucionInforme(tabRefCiclo.value)
            //Inertia.reload({ only: ['refresh_screen_operation_inertia']})// para que no aparesca la pantalla
        }

    } else {
        // Borrado o publicar
        axios.put(route(ruta, {
            'id': rowID.value,
        })).then((response) => {
            console.log('status ' + rowAction.value)
            cleanVal()
            listarEvolucionInforme(tabRefCiclo.value)
            Inertia.reload({ only: ['refresh_screen_operation_inertia'] })// para que no aparesca la ventanita blanca de Inertia
        }).catch((error) => { console.log(error) })
        /* Inertia.put(route(ruta, {
            'id' : rowID.value,
            }
        )) */
        //console.log('status ' + rowAction.value)
        //cleanVal()
        //listarTaskResponses()
        //Inertia.reload({ only: ['evolucion_informes']})
        //listarEvolucionInforme(tabRefCiclo.value)
        //Inertia.reload({ only: ['refresh_screen_operation_inertia']})// para que no aparesca la ventanita blanca de Inertia
    }

}

const isCancel = () => {

    cleanVal()
}

const refreshList = (action = []) => {
    /* if (action == 'asistencias') {
        Inertia.reload({ only: ['asistencia']})
    } else if (action == 'tareas') {
        Inertia.reload({ only: ['tasks']})
    } */
    Inertia.reload({ only: action })
    if (action.includes('taskResponses')) {
        listarTaskResponses()// <-- Por defecto id_task = 0
    }

}

const quillEditor = ref(null)// <-- Para limpiar contenido de editor
const cleanEditor = ref(true)

const cleanVal = (cleanEditor = 1) => {

    rowID.value = 0;
    rowAction.value = ''
    modalFullSrc.value = ''
    titleModal.value = ''
    rowParentID.value = ''
    sufijoTitle.value = ''
    chartCalifications.value = null

    // Tarea
    if (cleanEditor && (rowAction.value == 'actualizar' && rowAction.value == 'leer')) {// <-- No borrar si cierro el editor en nueva edición
        formInforme.id_student = 0
        formInforme.id_ciclo = null
        formInforme.informe = ''
        formInforme.status = 0
        quillEditor.value.setContents('')// <-- Limpiar contenido de texto enriquecido
    }
}

// Informe
const arrayInforme = ref([]);
const formInforme = useForm({
    id_student: 0,
    ref_ciclo: props.refCicloActual,
    informe: props.informeEvoInicial

});
console.log(props.ciclo_curricular)
console.log(props.informeEvoInicial)

const arrayEvolucionInformes = ref([]);
const tabRefCiclo = ref('');
// Sección Admisión puntajes
const listarEvolucionInforme = (ref_ciclo) => {
    tabRefCiclo.value = ref_ciclo
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/evolucioninforme/listarenaula' + '?id_classroom=' + props.classroom.id + '&ref_ciclo=' + ref_ciclo;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayEvolucionInformes.value = respuesta;
        //console.log(arrayCalifications.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const iniciarEvolucionInforme = (ref_ciclo) => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
      } */

    const newArr = [];
    const arr = props.students
    arr.forEach((student) => {

        newArr.push({
            id_student: student.id,
            //informe: formInforme.informe Ahora esta info será por Backend
        });

    });
    let ruta = 'evolucioninforme-registrar'
    if (newArr.length) {
        Inertia.post(route(ruta, {
            //'ref_ciclo': '2023B1',// formInforme.ref_ciclo <-- LRR Bimestr temporal a cambiar
            'ref_ciclo': ref_ciclo,// formInforme.ref_ciclo <-- LRR Bimestr temporal a cambiar
            'ciclo_curricular': props.ciclo_curricular,// Esto es el cliclo que determine Ugel, pj 1, 2, 3
            'arrayData': newArr,
        },
            {
                onSuccess: () => {
                    console.log('success')
                    //Inertia.reload({ only: ['evolucion_informes']})
                    listarEvolucionInforme(ref_ciclo)
                },
                onError: () => {
                    console.log('Error')
                }
            }
        ))
        //console.log(newArr)
        //Inertia.reload({ only: ['evolucion_informes']})

    }

    //return newArr;


}

// Publicar todo
const changeAllStatus = (ref_ciclo) => {
    const newArr = [];
    //const arr = props.evolucion_informes
    const arr = arrayEvolucionInformes.value
    arr.forEach((object) => {

        newArr.push({
            id_informe: object.id,
            //informe: formInforme.informe Ahora esta info será por Backend
        });

    });
    let ruta = 'evolucioninforme-publicar'
    if (newArr.length) {
        Inertia.put(route(ruta, {
            'action': 'publicartodo',
            'arrayData': newArr,
        },
            {
                onSuccess: () => {
                    console.log('success')
                    // NO llega hasta aquí
                    //listarEvolucionInforme(ref_ciclo)
                    //Inertia.reload({ only: ['refresh_screen_operation_inertia']})// para que no aparesca la pantalla
                },
                onError: () => {
                    console.log('Error')
                }
            }
        ))
        listarEvolucionInforme(ref_ciclo)
        Inertia.reload({ only: ['refresh_screen_operation_inertia'] })// para que no aparesca la pantalla
        //console.log(newArr)
        //Inertia.reload({ only: ['evolucion_informes']})

    }
}

const updateInforme = (id, asistencia = 1, content = '', percent = -1) => {
    let ruta = 'diario-actualizar'
    if (id > 0) {
        let titlesufijo = ' (A)'
        if (asistencia == 0) {
            titlesufijo = ' (F)'
        } else if (asistencia == 2) {
            titlesufijo = ' (T)'
        }
        axios.put(route(ruta), {
            'id': id,
            'title': props.course.label + titlesufijo,
            'asistencia': asistencia,
            'content': content,
            'percent': percent,
        }).then(function (response) {
            showAlert('Registro actualizado', 'success')
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
        });
        /* Inertia.put(route(ruta, {
            'id' : id,
            'title': props.course.label + titlesufijo,
            'asistencia' : asistencia,
            'content': content,
            'percent': percent,
            //onSuccess: () => { put.completed = true }
            }
        )) */
        //Inertia.reload({ only: ['message']})
    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}

const feedbackLabel = ref('');
const feedbackDesc = ref('');
const feedbackShow = ref(false);
let countAction = 0
let countActionOk = 0
let guardarTodo = 0



const showResp = ref([])// <-- Ver respuesta a cada tarea
const establecerShowResp = () => {
    if (taskResponses.value && taskResponses.value.length) {
        for (let i = 0; i < taskResponses.value.length; i++) {
            showResp.value[i] = false
        }
    }

}
const listarTaskResponses = (id_tarea = 0) => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/task/responses?id_course=' + props.course.id + '&id_classroom=' + props.classroom.id + '&id_task=' + id_tarea;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        taskResponses.value = respuesta;
        console.log(taskResponses.value);
        establecerShowResp()
    }).catch(function (error) {
        console.log(error);
    });
}

const diarioCollaborator = ref('')

const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}

/* const formatNotaOut = (nota) => {
    //$rango = [8 => 'C']
    let result = (nota < 10.5 ? 'C' : (nota >= 10.5 && nota < 12.5 ? 'B' : (nota >= 12.5 && nota < 16.5 ? 'A' : (nota >= 16.5 && nota <= 20 ? 'AD' : 'E'))))
    return result

}

const formatNotaIn = (nota) => {
    //$rango = [8 => 'C']
    let result = (nota == 'C' ? 10 : (nota == 'B' ? 13 : (nota == 'A' ? 17 : (nota == 'AD' ? 20 : 0))))
    return result

} */

const nota2number = (nota) => {
    let result = (nota == 'C' ? 10 : (nota == 'B' ? 13 : (nota == 'A' ? 17 : (nota == 'AD' ? 20 : 0))))
    return result
}

const number2nota = (notaN) => {
    let nota = parseFloat(notaN).toFixed(2);
    let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
    //console.log(nota)
    return result
}

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

// Se creó un compoente de alert
/* const notificationSettingsModel = ref([]);
const notificationsOutline = computed(
  () => notificationSettingsModel.value.indexOf("outline") > -1
); */

const isModalFormFullActive = ref(false);
//const isModalForm = ref(false); 

// Adjuntar archivo
const formFile = useForm({
    id: 0,
    file: null,
    filename: '',
    //oldfilepath: '',
    //oldfilename: '',
    originName: '',
    src_object_type: 'file_task',
    src_object_id: rowParentID.value ?? null,
    name: '',
    terms: false,
    type: ''
});


const isSaveFile = ref(false)
const isImagen = ref(false)
const imgMiniatura = ref('')
const handleFileUp = (event) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    //fileSubida.value = event.target.files[0];
    //console.log(event.target.files[0]);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (event.target.files && event.target.files.length) {
        formFile.originName = event.target.files[0].name
        if (formFile.originName.includes('.jpg') || formFile.originName.includes('.png')) {
            isImagen.value = true
        } else {
            isImagen.value = false
        }

        let file = event.target.files[0];
        //this.product.imagen=file
        formFile.file = file
        //console.log(file)
        console.log(formFile.file)
        fileUp(file)
    }

}

const fileUp = (file) => {
    let reader = new FileReader()
    reader.onload = (e) => {
        imgMiniatura.value = e.target.result
    }
    reader.readAsDataURL(file)
}

const registrarFile = () => {
    let currentObj = this;
    let ruta = 'file-adjunto-registrar'
    const config = {
        onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
    }
    axios.post(route(ruta), {

        'file': formFile.file,
        'filename': formFile.filename,
        'originName': formFile.originName,
        'src_object_type': formFile.src_object_type,
        'src_object_id': formFile.src_object_id,
        'name': formFile.name,
        'terms': formFile.terms,
        'type': formFile.type

    }, config).then(function (response) { // <-- config para enviara headers en este caso para subir archivo
        //Inertia.reload({ only: ['tasks']})
        isSaveFile.value = true
        //showAlert('Se adjuntó un archivo ', 'success', 2)
        responseMsg.value = response.data.success
        console.log('Adjuntado : ' + formFile.src_object_type + ' - ' + formFile.src_object_id);
    }).catch(function (error) {
        console.log(error);
        responseMsg.value = error

    });
}

const ShowDeleteFile = ref(false)
const deleteFile = (id_file, src_type = 'file_task') => {
    let ruta = 'file-adjunto-eliminar'
    axios.post(route(ruta), {
        'id': id_file,
        'src_object_type': src_type,

    }).then(function (response) {
        //Inertia.reload({ only: ['tasks']})
        showAlert('Se eliminó ' + id_file, 'success', 2)
        //console.log('Registro actualizado');
    }).catch(function (error) {
        console.log(error);
    });

    //isModalActive.value = false


    //alert(rutaPrefijo.value +'Hola '+rowID.value+'modal es '+rowAction.value)

    //cleanFile()
    //cleanVal()
    //refreshList(['tasks', 'taskResponses'])

}




/* Podrías solucionarlo así:

Para detectar la tecla presionada deberías utilizar key, ya que keyCode esta deprecado.

Para evitar que se envíe el formulario deberías utilizar preventDefault

Ejemplo: */
document.addEventListener('keypress', function (evt) {

    // Si el evento NO es una tecla Enter
    if (evt.key !== 'Enter') {
        return;
    }

    let element = evt.target;

    // Si el evento NO fue lanzado por un elemento con class "focusNext"
    if (!element.classList.contains('focusNext') && !element.classList.contains('focusNextConducta')) {
        return;
    }

    // AQUI logica para encontrar el siguiente
    let tabIndex = element.tabIndex + 1;
    var next = document.querySelector('[tabindex="' + tabIndex + '"]');

    // Si encontramos un elemento
    if (next) {
        next.focus();
        // No es neceasrio qye no usamos un form
        //Event.preventDefault();
    }

});

const backLink = ref(props.back_link ? '/#' + props.back_link : '')



// Gestión de asistencia
const fechaConsulta = ref(props.nowDate)
const arrayDiarios = ref([])
const bimestreConsultaDiarios = ref(props.refCicloActual)
//const arrayDiario = ref([]);
const formDiario = useForm({
    id_student: 0,
    //id_course: props.course.id,
    id_classroom: props.classroom.id,
    ref_ciclo: props.refCicloActual,
    fecha: props.nowDate,
    asistencia: 1,
    //title: props.course.label + ' (A)',
    title: '(A)',
    content: '',

    percent: -1

});
const iniciarAsistencia = (fecha = '') => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
    } */

    const newArr = [];
    const arr = props.students
    arr.forEach((student) => {

        newArr.push({
            id_student: student.id,
            //id_course: formDiario.id_course,
            id_classroom: formDiario.id_classroom,
            asistencia: formDiario.asistencia,
            title: formDiario.title,
            content: formDiario.content,
            fecha: (fecha ? fecha : formDiario.fecha),
            percent: formDiario.percent
        });

    });
    let ruta = 'diario-registrar'
    if (newArr.length) {
        axios.post(route(ruta), {
            'ref_ciclo': (bimestreConsultaDiarios.value ? bimestreConsultaDiarios.value : formDiario.ref_ciclo),
            'arrayData': newArr
        }).then((response) => {
            let respuesta = response.data
            if (respuesta.success) {
                showAlert(respuesta.message, 'success')
                listarAsistencia(fechaConsulta.value)
                //if (!props.debugDisableRefreshInertia) Inertia.reload({ only: ['diarios']})
            } else {
                showAlert(respuesta.message, 'danger', 16)
            }

        }).catch((error) => {
            console.log(error)
        });
        /* Inertia.post(route(ruta, {
            'ref_ciclo': formDiario.ref_ciclo,
            'arrayData' : newArr,
            }
        )) */
        //console.log(newArr)

    }

    //return newArr;


}

const listarAsistencia = (fecha = '') => {
    let url = '/diario/listar?id_classroom=' + props.classroom.id + '&fecha_consulta=' + fecha;
    axios.get(url).then((response) => {
        var respuesta = response.data;
        arrayDiarios.value = respuesta.lista;
        bimestreConsultaDiarios.value = respuesta.bimestre;
        //semanaConsulta.value = respuesta.semana;
        //this.items.push(obj);
        console.log(arrayDiarios.value);
    }).catch((error) => {
        console.log(error);
    });

}

/**
 * 
 * @param {*} id 
 * @param {*} asistencia 
 * @param {*} content 
 * @param {*} conducta <-- Deprecated
 * @param {*} percent 
 * conducta=0,
 */

const updateDiario = (id, asistencia = 1, content = '', percent = -1,) => {
    let ruta = 'diario-actualizar'
    //console.log(conducta)
    if (id > 0) {
        let titlesufijo = ' (A)'
        if (asistencia == 0) {
            titlesufijo = ' (F)'
        } else if (asistencia == 2) {
            titlesufijo = ' (T)'
        } else if (asistencia == 3) {
            titlesufijo = ' (FJ)'
        } else if (asistencia == 4) {
            titlesufijo = ' (TJ)'
        }
        axios.put(route(ruta), {
            'id': id,
            //'title': props.course.label + titlesufijo,
            'title': titlesufijo,
            'asistencia': asistencia,
            'content': content,
            //'calification_conducta': conducta,
            'percent': percent,
        }).then(function (response) {
            showAlert('Registro actualizado', 'success')
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
        });
        /* Inertia.put(route(ruta, {
            'id' : id,
            'title': props.course.label + titlesufijo,
            'asistencia' : asistencia,
            'content': content,
            'percent': percent,
            //onSuccess: () => { put.completed = true }
            }
        )) */
        //Inertia.reload({ only: ['message']})
    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}


// Gestión de conducta
//const arrayConducta = ref([]);
const arrayConductas = ref([])
const bimestreConsulta = ref(props.refCicloActual)
const semanaConsulta = ref(props.semanaActual)

const formConducta = useForm({
    id_student: 0,
    //id_course: props.course.id,
    id_classroom: props.classroom.id,
    ref_ciclo: props.refCicloActual,
    semana: props.semanaActual,
    calification_conducta: 18,
    //title: props.course.label + ' (A)',
    title: '(Conducta)',
    content: '',

    percent: -1

});
const iniciarConducta = (semana = '', bimestreref = '') => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
    } */

    const newArr = [];
    const arr = props.students
    arr.forEach((student) => {

        newArr.push({
            id_student: student.id,
            calification_conducta: formConducta.calification_conducta,
            content: formConducta.content
        });

    });
    let ruta = 'conducta-registrar'
    if (newArr.length) {
        axios.post(route(ruta), {
            'ref_ciclo': bimestreref ? bimestreref : formConducta.ref_ciclo,
            'id_classroom': formConducta.id_classroom,
            'title': formConducta.title,
            'semana': semana ? semana : formConducta.semana,
            'arrayData': newArr,
        }).then((response) => {
            let respuesta = response.data
            if (respuesta.success) {
                showAlert(respuesta.message, 'success')
                listarConductas(semanaConsulta.value)
                console.log('Estudiantes de conducta:')
                console.log(newArr)
            } else {
                showAlert(respuesta.message, 'danger', 16)
            }

        }).catch((error) => {
            console.log(error)
        });
        /* Inertia.post(route(ruta, {
            'ref_ciclo': bimestreref ? bimestreref : formConducta.ref_ciclo,
            'id_classroom': formConducta.id_classroom,
            'title': formConducta.title,
            'semana': semana ? semana : formConducta.semana,
            'arrayData' : newArr,
            }
        )) */
        //console.log(newArr)
        //if (!props.debugDisableRefreshInertia) Inertia.reload({ only: ['conductas']})
    }

    //return newArr;


}

/**
 * 
 * @param {*} id 
 * @param {*} asistencia 
 * @param {*} content 
 * @param {*} conducta <-- Deprecated
 * @param {*} percent 
 * conducta=0,
 */

const updateConducta = (id, calification_conducta = 20, content = '', percent = -1,) => {
    let ruta = 'conducta-actualizar'
    //console.log(conducta)
    if (id > 0) {
        let titlesufijo = ' (Conducta)'
        axios.put(route(ruta), {
            'id': id,
            'calification_conducta': calification_conducta,
            'content': content
        }).then(function (response) {
            //showAlert('Registro actualizado', 'success')   
            countAction++
            countActionOk++

            if (!guardarTodo) {
                showAlert(countAction + ' registro actualizado', 'success')
                countAction = 0
                countActionOk = 0
            } else {
                if (countAction == 1) {
                    showAlert('Validando, espere por favor ...', 'warning', 3)
                }

                if (arrayConductas.value && arrayConductas.value.length == countAction) {
                    showAlert(countActionOk + ' registros actualizados', 'success', 3)
                    countAction = 0
                    countActionOk = 0
                    guardarTodo = 0
                }
            }
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
            errors.value = 1
            countAction++

            showAlert(countAction + ' registro con error', 'danger', 10)
            if (!guardarTodo) {
                countAction = 0
            } else {
                if (arrayConductas.value && arrayConductas.value.length == countAction) {
                    countAction = 0
                    countActionOk = 0
                    guardarTodo = 0
                }
            }
        });
        /* Inertia.put(route(ruta, {
            'id' : id,
            'title': props.course.label + titlesufijo,
            'asistencia' : asistencia,
            'content': content,
            'percent': percent,
            //onSuccess: () => { put.completed = true }
            }
        )) */
        //Inertia.reload({ only: ['message']})
    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}

/**
 * Listar conducta
 * 
 */
const formCond = ref({
    nota: 18,
    observacion: ''
})
const listarConductas = (semana = 0) => {
    let url = '/conducta/listar?id_classroom=' + props.classroom.id + '&semana_consulta=' + semana;
    axios.get(url).then((response) => {
        var respuesta = response.data;
        /* const conductaArr = [];
        const conArr = respuesta.lista
        
        arrayConductas.value = [];
        conductaArr.push = respuesta.lista;
        conArr.forEach((conducta) => {

        }); */
        arrayConductas.value = respuesta.lista;
        bimestreConsulta.value = respuesta.bimestre;
        semanaConsulta.value = respuesta.semana;
        //this.items.push(obj);
        console.log(arrayConductas.value);
    }).catch((error) => {
        console.log(error);
    });

}

/***
 * LRR Notas
 * los tipos radio sólo se abren una vez, si se cambia a checkbox entonces se puede abrir independiente cada uno y cerrar
 */
</script>

<template>

    <Head :title="classroom.label" />
    <!-- <div v-if="isAlertActive" class="container mx-auto px-8 sticky top-1 z-50">
        <div class="grid-cols-1 w-full flex justify-end">
            <NotificationBar :color="colorAlert" :icon="(colorAlert=='success' ? mdiCheckCircle : (colorAlert=='warning' ? mdiContrastCircle : mdiAlertCircle))"
                :outline="notificationsOutline"  class="col-span-1 p-2 lg:p-4 absolute">
                <b v-if="colorAlert=='success'">Ok </b>
                <b v-else-if="colorAlert=='warning'">! </b>
                <b v-else-if="colorAlert=='danger'">Error </b>
                <span class="mr-3" v-text="messageAlert"></span>
            </NotificationBar>
        </div>
    </div> -->
    <!-- Analizar esto, los alert tiene que star debajo de otro-->
    <NotificationAlert v-model="isAlertDangerActive" :message="messageAlert" color="danger" />
    <!-- <NotificationAlert v-model="success" :message="$page.props.flash.message" color="warning" /> -->
    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />
    <!-- <div v-if="isAlertActive" class="container mx-auto px-8 sticky top-1 z-50">
        <div class="grid-cols-1 w-full flex justify-end">
            <div class="col-span-1 p-2 lg:p-4 absolute">
                <div>
                    <div class="py-3 px-5 text-blue-900 text-sm rounded-md border border-blue-200 flex items-center justify-between"
                    role="alert" :class="(colorAlert=='warning' ? 'bg-yellow-100' : (colorAlert=='danger' ? 'bg-red-100' : 'bg-green-100'))">
                    <span class="mr-3">{{ messageAlert }}</span>
                    <button class="h-6 w-6" type="button" data-dismiss="alert" aria-label="Close"
                        onclick="this.parentElement.remove();">
                        <BaseIcon :path="mdiCloseThick" class="text-gray-700" :size="28" />
                    </button>
                </div>
                </div>
                
            </div>
        </div>
    </div> -->


    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between w-full">
                <div class="flex items-center gap-3">
                    <div class="p-2.5 bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400 rounded-2xl shadow-sm">
                        <Icon icon="tabler:chalkboard" class="w-7 h-7" />
                    </div>
                    <div>
                        <h2 class="font-extrabold text-xl lg:text-2xl text-slate-800 dark:text-white leading-tight">
                            Aula: {{ classroom.label }}
                        </h2>
                        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
                            Periodo: {{ classroom.ref }} • Alumnos: {{ students.length }}
                        </p>
                    </div>
                </div>
                <div class="flex items-center gap-2">
                    <Link v-if="backLink" :href="route('classrooms-collaborator') + backLink">
                        <button class="btn-premium-secondary flex items-center gap-1.5">
                            <Icon icon="tabler:arrow-left" class="w-4 h-4" />
                            <span>Volver al Listado</span>
                        </button>
                    </Link>
                    <Link v-else :href="route('classrooms-collaborator')">
                        <button class="btn-premium-secondary flex items-center gap-1.5">
                            <Icon icon="tabler:arrow-left" class="w-4 h-4" />
                            <span>Volver al Listado</span>
                        </button>
                    </Link>
                </div>
            </div>
        </template>


        <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel><!-- tien el botón de cancelar superior-->
            <div class="flex justify-center w-full">
                <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full"><!-- w-full es para documetnos w-auto para imágenes-->
            </div>
        </CardBoxModal>
        <!-- Tareas -->
        <CardBoxModal v-model="isModalActive" hasCancel :title="(titleModal + sufijoTitle)" @confirm="isConfirm" @cancel="isCancel" sizeModal="medium" :noButtons="(rowAction == 'leer' || rowAction == 'showPromedios' ? true : false)">

            <!-- grafica -->
            <div v-if="rowAction == 'showPromedios'">
                <div class="w-full justify-between flex">
                    <div>
                        <select v-model="chartSelectCiclo" @change="listarChartCalification(chartSelectCiclo, rowID)">
                            <option value="" disabled>Escoja el Bimestre</option>
                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'" selected>Primer Bimestre</option>
                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'" selected>Segundo Bimestre</option>
                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'" selected>Tercer Bimestre</option>
                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'" selected>Cuarto Bimestre</option>
                        </select>
                    </div>

                </div>
                <div class="p-4 mt-4">
                    <div v-if="chartCalifications">
                        <CompetencyGraphic :data="chartCalifications" heightClass="h-96" />
                    </div>
                </div>
            </div>

            <!-- Formularios informe de evolución -->
            <div v-else class="overflow-y-auto">
                <div v-if="isErrorForm" class="mb-4">
                    <div class="font-medium text-red-600">Ups! Debe registrar los campos requeridos</div>
                </div>
                <div>
                    <select v-model="formInforme.ref_ciclo" :disabled="(rowAction == 'leer' ? true : false)" required class=" w-full">
                        <option value="" disabled>Selección del Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'" selected>Primer Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'" selected>Segundo Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'" selected>Tercer Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'" selected>Cuarto Bimestre</option>
                    </select>
                </div>

                <div class="mt-4">

                    <!-- <span>Descripción (Html) <span class="text-red-600" > * </span></span><span @click="showHtmlText=!showHtmlText">Vista previa<BaseIcon :path="mdiEye" :size="18" class="mr-3 " /></span>
                    <
                    <div v-else class="p-2" v-html="form.description"></div> -->
                    <BreezeLabel for="description" value="Reemplace las competencias por su informe, puede ser detallado por competencia o general como área" />
                    <!-- PRopiedades: readOnly, toolbar="" -> Sin toolbar, :toolbar="['']" -> Agregar toolbarr personalizado sólo resaltado y sub indice -->
                    <QuillEditor v-if="rowAction == 'leer'" ref="quillEditor" class="max-h-[450px] overflow-y-auto min-h-[300px]" v-model:content="formInforme.informe" contentType="html" :toolbar="[]" theme="snow" readOnly />
                    <QuillEditor v-else ref="quillEditor" class="max-h-[450px] overflow-y-auto min-h-[300px]" v-model:content="formInforme.informe" contentType="html" toolbar="essential" theme="snow" />

                </div>
            </div>


        </CardBoxModal>
        <CardBoxModal v-model="isModalDangerActive" title="Por Confirmar" button="danger" hasCancel @confirm="isConfirm" @cancel="isCancel">
            <p>Está seguro de <b>{{ titleModal }}</b></p>
            <p>este registro?</p>
        </CardBoxModal>

        <!-- Modal con vista previa -->
        <CardBoxModal v-model="isModalFormFullActive" title="Vista previa" sizeModal="formfull" hasCancel>
            <!-- tien el botón de cancelar superior-->
            <div class="grid grid-cols-5 gap-4">
                <div class="col-span-4">
                    <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full">
                </div>
                <div class="col-span-1 grid h-full content-between">
                    <div class="w-full">
                        <div v-if="isErrorForm" class="mb-2">
                            <div class="font-small text-red-600">Ups! Debe registrar la calificación</div>
                        </div>
                        <h2 class="mb-4">Calificación</h2>
                        <input class="rounded-lg w-full mb-3" type="text" v-model="formTarea.calification" placeholder="Nota" @focus="$event.target.select()" :disabled="(rowAction == 'tarearesponse-leerresp-adjunto' ? true : false)">
                        <h2 class="mb-4 mt-4">Comentario (opcional)</h2>
                        <QuillEditor class="rounded-lg w-full mb-3" ref="tareaEditor" style="min-height:20px;" v-model:content="formTarea.description_collaborator" contentType="html" :toolbar="(rowAction == 'tarearesponse-leerresp-adjunto' ? [] : 'essential')" theme="snow" :readOnly="(rowAction == 'tarearesponse-leerresp-adjunto' ? true : false)" />
                        <!-- <input class="rounded-lg w-full mb-3 mt-2" type="text" v-model="formTarea.description_collaborator" placeholder="Comentarios (opcional)" :disabled="(rowAction == 'tarearesponse-leerresp-adjunto' ? true : false)"> -->
                        <!-- <input class="rounded-lg w-full mb-3" type="text" placeholder="Ingresa aqui"> -->
                    </div>
                    <div v-if="rowAction != 'tarearesponse-leerresp-adjunto'" class="w-full flex flex-col">
                        <div>
                            <BaseButton color="success" :icon="mdiCheckBold" small label="Aceptar" class="inline w-full mb-3" @click="isConfirm" />
                        </div>
                        <div>
                            <BaseButton color="danger" :icon="mdiArrowLeftTopBold" small label="Cancelar" class="inline w-full" @click="isCancel, isModalFormFullActive = false" />
                        </div>
                    </div>

                </div>
            </div>
        </CardBoxModal>
        
        <section>
            <div>
                <!-- Herramientas -->
                <div class="pb-4">
                    <div class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-12 gap-4">
                        <!-- Nota Privada -->
                        <div class="lg:col-span-2 xl:col-span-8">
                            <div v-if="arrayPostit.length" v-for="(obj) in arrayPostit" :key="obj.id">
                                <div class="bg-amber-50 border border-amber-200/60 rounded-2xl shadow-sm h-[120px] flex flex-col overflow-hidden">
                                    <div class="flex justify-between items-center px-4 py-2 bg-amber-100/50 border-b border-amber-200/40">
                                        <div class="flex items-center gap-2">
                                            <Icon icon="tabler:note" class="w-4 h-4 text-amber-700" />
                                            <span class="text-xs font-semibold text-amber-800">Nota Privada</span>
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <button @click="updateOrCreatePostit(obj.id, obj.description)" class="text-amber-700 hover:text-amber-900 transition-colors" title="Guardar Nota">
                                                <Icon icon="tabler:device-floppy" class="w-4.5 h-4.5" />
                                            </button>
                                            <span v-if="alertPostit" class="text-[10px] text-amber-700 font-medium animate-pulse">{{ alertPostit }}</span>
                                        </div>
                                    </div>
                                    <div class="p-3 flex-1">
                                        <textarea class="resize-none block w-full h-full p-0 text-sm text-amber-900 bg-transparent border-none focus:ring-0 focus:outline-none placeholder-amber-600/50" v-model="obj.description" placeholder="Escribe una nota rápida aquí..."></textarea>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="bg-amber-50 border border-amber-200/60 rounded-2xl shadow-sm h-[120px] flex flex-col overflow-hidden">
                                    <div class="flex justify-between items-center px-4 py-2 bg-amber-100/50 border-b border-amber-200/40">
                                        <div class="flex items-center gap-2">
                                            <Icon icon="tabler:note" class="w-4 h-4 text-amber-700" />
                                            <span class="text-xs font-semibold text-amber-800">Nota Privada</span>
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <button @click="updateOrCreatePostit(0, postitDescription)" class="text-amber-700 hover:text-amber-900 transition-colors" title="Guardar Nota">
                                                <Icon icon="tabler:plus" class="w-4.5 h-4.5" />
                                            </button>
                                            <span v-if="alertPostit" class="text-[10px] text-amber-700 font-medium animate-pulse">{{ alertPostit }}</span>
                                        </div>
                                    </div>
                                    <div class="p-3 flex-1">
                                        <textarea class="resize-none block w-full h-full p-0 text-sm text-amber-900 bg-transparent border-none focus:ring-0 focus:outline-none placeholder-amber-600/50" v-model="postitDescription" placeholder="Escribe una nota rápida aquí..."></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Calendario Widget -->
                        <div class="lg:col-span-1 xl:col-span-4">
                            <div class="bg-gradient-to-br from-rose-500 to-pink-600 rounded-2xl shadow-sm p-4 text-white flex items-center justify-between h-[120px]">
                                <div class="flex items-center gap-3">
                                    <div class="bg-white/20 p-2.5 rounded-xl backdrop-blur-sm">
                                        <Icon icon="tabler:calendar-event" class="w-7 h-7 text-white" />
                                    </div>
                                    <div>
                                        <p class="text-[10px] text-white/80 font-medium uppercase tracking-wider">{{ nowDayLetter }}</p>
                                        <p class="text-xl font-bold leading-tight">{{ nowDay }}</p>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div class="bg-black/15 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-1 border border-white/10">
                                        Semana {{ semanaActual }}
                                    </div>
                                    <p class="text-xs text-white/90 font-medium">{{ bimestreActual }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tabs -->
                <div class="mt-6">
                    <!-- Modern Horizontal Tab Menu -->
                    <div class="flex overflow-x-auto gap-2 bg-slate-100/80 dark:bg-slate-800/80 p-1.5 rounded-2xl w-max max-w-full custom-scrollbar mb-6">
                        <!-- Tab 0: Resumen -->
                        <button @click="mainTab = 0" class="tab-btn-premium" :class="mainTab == 0 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:dashboard" class="w-4 h-4" />
                                Resumen
                            </span>
                        </button>

                        <!-- Tab 1: Listado de alumnos -->
                        <button @click="mainTab = 1" class="tab-btn-premium" :class="mainTab == 1 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:users-group" class="w-4 h-4" />
                                Alumnos
                            </span>
                        </button>

                        <!-- Tab Agenda: Agenda diaria del aula -->
                        <button @click="mainTab = 'agenda'" class="tab-btn-premium" :class="mainTab === 'agenda' ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:notebook" class="w-4 h-4 text-rose-500" />
                                Agenda
                            </span>
                        </button>

                        <!-- Tab 2: Registro de asistencia -->
                        <button v-if="!isPsico && !isSecre" @click="mainTab = 2" class="tab-btn-premium" :class="mainTab == 2 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:calendar-check" class="w-4 h-4" />
                                Asistencia
                            </span>
                        </button>

                        <!-- Tab 3: Conducta -->
                        <button v-if="!isPsico && !isSecre" @click="mainTab = 3" class="tab-btn-premium" :class="mainTab == 3 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:mood-smile" class="w-4 h-4" />
                                Conducta
                            </span>
                        </button>

                        <!-- Tab 4: Informes de evolución -->
                        <button v-if="!isPsico && !isSecre" @click="mainTab = 4" class="tab-btn-premium" :class="mainTab == 4 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:report-medical" class="w-4 h-4" />
                                Informes de evolución
                            </span>
                        </button>

                        <!-- Tab 5: Calificaciones -->
                        <button v-if="!isPsico" @click="mainTab = 5" class="tab-btn-premium" :class="mainTab == 5 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:award" class="w-4 h-4" />
                                Calificaciones
                            </span>
                        </button>

                        <!-- Tab 6: Puntajes simulacro -->
                        <button v-if="confGlobal.value.ACADEMICO_USE_SIMULACRO_ADMISION == 1 && !isPsico && !isSecre" @click="mainTab = 6" class="tab-btn-premium" :class="mainTab == 6 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:certificate" class="w-4 h-4" />
                                Puntajes EAP
                            </span>
                        </button>

                        <!-- Tab 7: Financiero -->
                        <button v-if="!isPsico && !isSecre" @click="mainTab = 7" class="tab-btn-premium" :class="mainTab == 7 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                            <span class="flex items-center gap-2">
                                <Icon icon="tabler:currency-dollar" class="w-4 h-4" />
                                Financiero
                            </span>
                        </button>
                    </div>
                    <div class="w-full">

                        <!-- Resumen / Dashboard -->
                        <div v-if="mainTab == 0" class="space-y-6">
                            <!-- Dashboard KPI Grid -->
                            <!-- <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                                 Card 1: Total Estudiantes 
                                <div class="bg-gradient-to-br from-violet-500 to-indigo-600 rounded-3xl p-5 text-white shadow-md relative overflow-hidden flex flex-col justify-between h-[130px] group hover:scale-[1.02] transition-transform duration-300">
                                    <div class="absolute -right-6 -bottom-6 text-white/10 group-hover:scale-110 transition-transform duration-300">
                                        <Icon icon="tabler:users-group" class="w-28 h-28" />
                                    </div>
                                    <div class="flex justify-between items-start">
                                        <div>
                                            <p class="text-xs text-white/80 font-medium uppercase tracking-wider">Estudiantes Activos</p>
                                            <h3 class="text-3xl font-extrabold mt-1">{{ students.length }}</h3>
                                        </div>
                                        <div class="bg-white/15 p-2 rounded-2xl backdrop-blur-md">
                                            <Icon icon="tabler:users" class="w-6 h-6" />
                                        </div>
                                    </div>
                                    <div class="flex items-center gap-1.5 text-xs text-white/90">
                                        <span class="inline-flex w-2.5 h-2.5 bg-emerald-400 rounded-full animate-ping"></span>
                                        <span>Matrícula escolar activa</span>
                                    </div>
                                </div>

                                Card 2: Asistencia Registrada
                                <div class="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-3xl p-5 text-white shadow-md relative overflow-hidden flex flex-col justify-between h-[130px] group hover:scale-[1.02] transition-transform duration-300">
                                    <div class="absolute -right-6 -bottom-6 text-white/10 group-hover:scale-110 transition-transform duration-300">
                                        <Icon icon="tabler:calendar-check" class="w-28 h-28" />
                                    </div>
                                    <div class="flex justify-between items-start">
                                        <div>
                                            <p class="text-xs text-white/80 font-medium uppercase tracking-wider">Asistencias del Día</p>
                                            <h3 class="text-3xl font-extrabold mt-1">{{ arrayDiarios.length }}</h3>
                                        </div>
                                        <div class="bg-white/15 p-2 rounded-2xl backdrop-blur-md">
                                            <Icon icon="tabler:calendar-user" class="w-6 h-6" />
                                        </div>
                                    </div>
                                    <p class="text-xs text-white/90">
                                        {{ arrayDiarios.length > 0 ? 'Asistencia registrada hoy' : 'Registro pendiente para hoy' }}
                                    </p>
                                </div>

                                Card 3: Conducta Semanal
                                <div class="bg-gradient-to-br from-amber-500 to-orange-600 rounded-3xl p-5 text-white shadow-md relative overflow-hidden flex flex-col justify-between h-[130px] group hover:scale-[1.02] transition-transform duration-300">
                                    <div class="absolute -right-6 -bottom-6 text-white/10 group-hover:scale-110 transition-transform duration-300">
                                        <Icon icon="tabler:mood-smile" class="w-28 h-28" />
                                    </div>
                                    <div class="flex justify-between items-start">
                                        <div>
                                            <p class="text-xs text-white/80 font-medium uppercase tracking-wider">Conductas de la Semana</p>
                                            <h3 class="text-3xl font-extrabold mt-1">{{ arrayConductas.length }}</h3>
                                        </div>
                                        <div class="bg-white/15 p-2 rounded-2xl backdrop-blur-md">
                                            <Icon icon="tabler:award" class="w-6 h-6" />
                                        </div>
                                    </div>
                                    <p class="text-xs text-white/90">
                                        {{ arrayConductas.length > 0 ? 'Calificaciones ingresadas' : 'Pendiente ingresar conducta' }}
                                    </p>
                                </div>

                                Card 4: Salud Financiera
                                <div class="bg-gradient-to-br from-rose-500 to-pink-600 rounded-3xl p-5 text-white shadow-md relative overflow-hidden flex flex-col justify-between h-[130px] group hover:scale-[1.02] transition-transform duration-300">
                                    <div class="absolute -right-6 -bottom-6 text-white/10 group-hover:scale-110 transition-transform duration-300">
                                        <Icon icon="tabler:currency-dollar" class="w-28 h-28" />
                                    </div>
                                    <div class="flex justify-between items-start">
                                        <div>
                                            <p class="text-xs text-white/80 font-medium uppercase tracking-wider">Cobranza / Deudas</p>
                                            <h3 class="text-3xl font-extrabold mt-1">{{ arrayDeudores.length }}</h3>
                                        </div>
                                        <div class="bg-white/15 p-2 rounded-2xl backdrop-blur-md">
                                            <Icon icon="tabler:wallet" class="w-6 h-6" />
                                        </div>
                                    </div>
                                    <p class="text-xs text-white/90">
                                        {{ arrayDeudores.length > 0 ? 'Estudiantes con pagos pendientes' : 'Sin deudas registradas' }}
                                    </p>
                                </div>
                            </div> -->

                            <!-- Main Dashboard Grid -->
                            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                <!-- Left/Center Panel (ColSpan 2) -->
                                <div class="lg:col-span-2 space-y-6">
                                    <!-- Contenido del Aula Table card -->
                                    <div class="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800/80 rounded-3xl p-6 shadow-sm">
                                        <div class="flex items-center justify-between mb-4">
                                            <div class="flex items-center gap-2.5">
                                                <div class="p-2 bg-rose-50 dark:bg-rose-950/40 text-rose-500 rounded-xl">
                                                    <Icon icon="tabler:article" class="w-5 h-5" />
                                                </div>
                                                <div>
                                                    <h3 class="font-bold text-lg text-slate-800 dark:text-white">Estado de Gestión del Aula</h3>
                                                    <p class="text-xs text-slate-500 dark:text-slate-400">Información del aula no relacionada a un curso específico</p>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Checklist & Details -->
                                        <div class="space-y-4">
                                            <div class="flex items-center justify-between p-3.5 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-slate-100 dark:border-slate-800/30">
                                                <div class="flex items-center gap-3">
                                                    <Icon icon="tabler:calendar-check" class="w-5 h-5 text-emerald-500" />
                                                    <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Asistencia del día</span>
                                                </div>
                                                <span v-if="arrayDiarios.length > 0" class="badge-premium-success text-xs">{{ arrayDiarios.length }} Completados </span>
                                                <span v-else class="badge-premium-danger text-xs">Pendiente</span>
                                            </div>

                                            <div class="flex items-center justify-between p-3.5 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-slate-100 dark:border-slate-800/30">
                                                <div class="flex items-center gap-3">
                                                    <Icon icon="tabler:mood-smile" class="w-5 h-5 text-amber-500" />
                                                    <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Conducta de la semana</span>
                                                </div>
                                                <span v-if="arrayConductas.length > 0" class="badge-premium-success text-xs">{{ arrayConductas.length }} Calificados</span>
                                                <span v-else class="badge-premium-danger text-xs">Por Calificar</span>
                                            </div>

                                            <div class="flex items-center justify-between p-3.5 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-slate-100 dark:border-slate-800/30">
                                                <div class="flex items-center gap-3">
                                                    <Icon icon="tabler:currency-dollar" class="w-5 h-5 text-rose-500" />
                                                    <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Cobranza y Pensiones</span>
                                                </div>
                                                <span v-if="arrayDeudores.length > 0" class="badge-premium-warning text-xs">{{ arrayDeudores.length }} Pendientes</span>
                                                <span v-else class="badge-premium-success text-xs">Al Día</span>
                                            </div>
                                        </div>

                                        <!-- Fast Navigation Buttons -->
                                        <!-- <div class="mt-6 border-t border-slate-100 dark:border-slate-800 pt-5">
                                            <h4 class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-3">Accesos Rápidos de Gestión</h4>
                                            <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                                                <button @click="mainTab = 2" class="p-3 bg-slate-50 dark:bg-slate-800/60 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-2xl text-center border border-slate-100 dark:border-slate-800/50 transition-colors flex flex-col items-center justify-center gap-1.5">
                                                    <Icon icon="tabler:calendar-check" class="w-5 h-5 text-indigo-500" />
                                                    <span class="text-xs font-semibold text-slate-700 dark:text-slate-300">Asistencia</span>
                                                </button>
                                                <button @click="mainTab = 3" class="p-3 bg-slate-50 dark:bg-slate-800/60 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-2xl text-center border border-slate-100 dark:border-slate-800/50 transition-colors flex flex-col items-center justify-center gap-1.5">
                                                    <Icon icon="tabler:mood-smile" class="w-5 h-5 text-amber-500" />
                                                    <span class="text-xs font-semibold text-slate-700 dark:text-slate-300">Conducta</span>
                                                </button>
                                                <button @click="mainTab = 5" class="p-3 bg-slate-50 dark:bg-slate-800/60 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-2xl text-center border border-slate-100 dark:border-slate-800/50 transition-colors flex flex-col items-center justify-center gap-1.5">
                                                    <Icon icon="tabler:award" class="w-5 h-5 text-emerald-500" />
                                                    <span class="text-xs font-semibold text-slate-700 dark:text-slate-300">Notas</span>
                                                </button>
                                                <button @click="mainTab = 7" class="p-3 bg-slate-50 dark:bg-slate-800/60 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-2xl text-center border border-slate-100 dark:border-slate-800/50 transition-colors flex flex-col items-center justify-center gap-1.5">
                                                    <Icon icon="tabler:currency-dollar" class="w-5 h-5 text-rose-500" />
                                                    <span class="text-xs font-semibold text-slate-700 dark:text-slate-300">Finanzas</span>
                                                </button>
                                            </div>
                                        </div> -->
                                    </div>

                                    <!-- HORARIO DE CURSOS (Recuadro Inicial Solicitado) -->
                                    <div class="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800/80 rounded-3xl p-6 shadow-sm">
                                        <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
                                            <div class="flex items-center gap-2.5">
                                                <div class="p-2 bg-indigo-50 dark:bg-indigo-950/40 text-indigo-600 rounded-xl">
                                                    <Icon icon="tabler:calendar-time" class="w-5 h-5" />
                                                </div>
                                                <div>
                                                    <h3 class="font-bold text-lg text-slate-800 dark:text-white">Horario de Cursos</h3>
                                                    <p class="text-xs text-slate-500 dark:text-slate-400">Distribución de clases activas y recreos de Lunes a Viernes</p>
                                                </div>
                                            </div>

                                            <button @click="isScheduleModalOpen = true" class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 dark:bg-indigo-950/50 hover:bg-indigo-100 text-indigo-600 dark:text-indigo-400 rounded-xl text-xs font-bold transition border border-indigo-200/50 dark:border-indigo-900/50">
                                                <Icon icon="tabler:settings" class="w-4 h-4" />
                                                Configurar Horario
                                            </button>
                                        </div>

                                        <!-- Grilla Semanal Visual -->
                                        <div v-if="scheduleList.length > 0" class="overflow-x-auto">
                                            <div class="grid grid-cols-5 gap-2.5 min-w-[650px]">
                                                <div v-for="day in daysOfWeekList" :key="day.id" class="flex flex-col bg-slate-50 dark:bg-slate-800/40 p-2.5 rounded-2xl border border-slate-100 dark:border-slate-800/40">
                                                    <div class="text-xs font-bold text-slate-700 dark:text-slate-200 mb-2 pb-1 border-b border-slate-200/60 dark:border-slate-700/60 flex items-center justify-between">
                                                        <span>{{ day.label }}</span>
                                                        <span class="text-[10px] text-slate-400">
                                                            {{ scheduleList.filter(s => s.day_of_week === day.id).length }} blq.
                                                        </span>
                                                    </div>

                                                    <div class="space-y-1.5">
                                                        <template v-for="slot in scheduleList.filter(s => s.day_of_week === day.id)" :key="slot.id || (slot.day_of_week + slot.start_time)">
                                                            <!-- Recreo -->
                                                            <div v-if="slot.type === 'recreo'" class="p-1.5 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-700 dark:text-amber-400 text-center">
                                                                <div class="flex items-center justify-center gap-1 text-[10px] font-bold">
                                                                    <Icon icon="tabler:coffee" class="w-3 h-3" />
                                                                    {{ slot.label_break || 'Recreo' }}
                                                                </div>
                                                                <span class="text-[9px] text-amber-600/70 font-mono">{{ slot.start_time }} - {{ slot.end_time }}</span>
                                                            </div>
                                                            <!-- Clase -->
                                                            <div v-else class="p-2 rounded-xl bg-white dark:bg-slate-800 border border-slate-200/70 dark:border-slate-700/60 shadow-xs hover:border-indigo-300 transition">
                                                                <p class="text-[11px] font-bold text-slate-800 dark:text-slate-100 truncate" :title="slot.course ? slot.course.label : 'Curso'">
                                                                    {{ slot.course ? slot.course.label : 'Curso' }}
                                                                </p>
                                                                <div class="flex items-center justify-between mt-1 text-[9px] text-slate-400 font-mono">
                                                                    <span>{{ slot.start_time }}</span>
                                                                    <span>-</span>
                                                                    <span>{{ slot.end_time }}</span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <div v-if="scheduleList.filter(s => s.day_of_week === day.id).length === 0" class="py-4 text-center text-[11px] text-slate-400 italic">
                                                            Sin clases
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="text-center py-8 bg-slate-50 dark:bg-slate-800/30 rounded-2xl border border-dashed border-slate-200 dark:border-slate-800">
                                            <Icon icon="tabler:calendar-time" class="w-10 h-10 text-slate-300 dark:text-slate-600 mx-auto mb-2" />
                                            <p class="text-xs font-semibold text-slate-500 dark:text-slate-400">Aún no se ha configurado el horario semanal de este aula.</p>
                                            <button @click="isScheduleModalOpen = true" class="mt-3 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold transition shadow-sm">
                                                Configurar Horario Ahora
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Right Panel (ColSpan 1) -->
                                <div class="space-y-6">
                                    <!-- Informacion de Aula Card -->
                                    <div class="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800/80 rounded-3xl p-6 shadow-sm relative overflow-hidden flex flex-col justify-between">
                                        <div>
                                            <div class="flex items-center gap-2.5 mb-4">
                                                <div class="p-2 bg-indigo-50 dark:bg-indigo-950/40 text-indigo-500 rounded-xl">
                                                    <Icon icon="tabler:school" class="w-5 h-5" />
                                                </div>
                                                <h3 class="font-bold text-lg text-slate-800 dark:text-white">Detalles del Aula</h3>
                                            </div>
                                            <div class="space-y-3.5">
                                                <div class="flex justify-between items-center text-sm">
                                                    <span class="text-slate-500 dark:text-slate-400 font-medium">Aula / Grado:</span>
                                                    <span class="font-bold text-slate-800 dark:text-slate-200 bg-slate-100 dark:bg-slate-800 px-2.5 py-0.5 rounded-full text-xs">{{ classroom.label }}</span>
                                                </div>
                                                <div class="flex justify-between items-center text-sm">
                                                    <span class="text-slate-500 dark:text-slate-400 font-medium">Año Escolar:</span>
                                                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{ anioEscolar }}</span>
                                                </div>
                                                <div class="flex justify-between items-center text-sm">
                                                    <span class="text-slate-500 dark:text-slate-400 font-medium">Bimestre:</span>
                                                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{ refCicloActual }}</span>
                                                </div>
                                                <div class="flex justify-between items-center text-sm">
                                                    <span class="text-slate-500 dark:text-slate-400 font-medium">Semana Actual:</span>
                                                    <span class="font-semibold text-slate-700 dark:text-slate-300">{{ semanaActual }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Motivational card inside -->
                                        <div class="mt-6 bg-gradient-to-br from-indigo-50 to-violet-50 dark:from-indigo-950/20 dark:to-violet-950/20 p-4 rounded-2xl border border-indigo-100/50 dark:border-indigo-950/30">
                                            <div class="flex items-start gap-2.5">
                                                <Icon icon="tabler:quote" class="w-5 h-5 text-indigo-500 flex-shrink-0" />
                                                <p class="text-xs text-indigo-900/80 dark:text-indigo-300/80 font-medium leading-relaxed italic">
                                                    "La educación no es la preparación para la vida; la educación es la vida misma." - John Dewey
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- PESTAÑA AGENDA ESCOLAR DIGITAL (Formatos Físicos de Ejemplo) -->
                        <div v-if="mainTab === 'agenda'" class="space-y-6">
                            <!-- Header de Navegación de Fecha y Controles -->
                            <div class="card-premium">
                                <div class="flex flex-wrap items-center justify-between gap-4">
                                    <div class="flex items-center gap-3">
                                        <button @click="changeAgendaDate(-1)" class="p-2 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 transition" title="Día anterior">
                                            <Icon icon="tabler:chevron-left" class="w-5 h-5" />
                                        </button>
                                        <button @click="agendaDate = props.nowDate || getLocalDateString(); fetchDailyAgenda(agendaDate);" class="px-3 py-1.5 bg-indigo-50 dark:bg-indigo-950/50 hover:bg-indigo-100 text-indigo-600 dark:text-indigo-400 rounded-xl text-xs font-bold transition border border-indigo-200/50 dark:border-indigo-900/50">
                                            Hoy
                                        </button>
                                        <button @click="changeAgendaDate(1)" class="p-2 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 transition" title="Día siguiente">
                                            <Icon icon="tabler:chevron-right" class="w-5 h-5" />
                                        </button>

                                        <input type="date" :value="agendaDate" @change="onAgendaDateChange" class="text-xs font-bold rounded-xl border-slate-200 dark:border-slate-700 dark:bg-slate-800 px-3 py-1.5 text-slate-700 dark:text-slate-200 cursor-pointer" />
                                    </div>

                                    <!-- Badges tipo Cuaderno Físico: DAY, Month, Week, Year -->
                                    <div class="flex flex-wrap items-center gap-2">
                                        <div class="flex items-center gap-1.5 px-3 py-1 bg-rose-500/10 border border-rose-500/30 rounded-xl text-xs font-extrabold text-rose-600 dark:text-rose-400">
                                            <span class="text-[10px] uppercase font-bold text-rose-400">DAY:</span>
                                            <span>{{ agendaHeader.dayName }} {{ agendaHeader.dayNumber }}</span>
                                        </div>
                                        <div class="flex items-center gap-1.5 px-3 py-1 bg-indigo-500/10 border border-indigo-500/30 rounded-xl text-xs font-extrabold text-indigo-600 dark:text-indigo-400">
                                            <span class="text-[10px] uppercase font-bold text-indigo-400">Month:</span>
                                            <span>{{ agendaHeader.monthName }}</span>
                                        </div>
                                        <div class="flex items-center gap-1.5 px-3 py-1 bg-amber-500/10 border border-amber-500/30 rounded-xl text-xs font-extrabold text-amber-600 dark:text-amber-400">
                                            <span class="text-[10px] uppercase font-bold text-amber-400">Week:</span>
                                            <span>Semana {{ agendaHeader.weekNumber }}</span>
                                        </div>
                                        <div class="flex items-center gap-1.5 px-3 py-1 bg-emerald-500/10 border border-emerald-500/30 rounded-xl text-xs font-extrabold text-emerald-600 dark:text-emerald-400">
                                            <span class="text-[10px] uppercase font-bold text-emerald-400">Year:</span>
                                            <span>{{ agendaHeader.year }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- PARTE SUPERIOR: AGENDA GENERAL DEL AULA (SUBJECT, TOPICS, HOME WORKS) -->
                            <div class="card-premium">
                                <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
                                    <div class="flex items-center gap-2.5">
                                        <div class="p-2 bg-rose-500/10 text-rose-600 rounded-xl">
                                            <Icon icon="tabler:notebook" class="w-5 h-5" />
                                        </div>
                                        <div>
                                            <h3 class="font-bold text-base text-slate-800 dark:text-white">Agenda del Aula - Cursos, Temas y Tareas</h3>
                                            <p class="text-xs text-slate-500 dark:text-slate-400">Información para todos los estudiantes según el horario de hoy</p>
                                        </div>
                                    </div>

                                    <div class="flex items-center gap-2">
                                        <button @click="addAgendaRow" class="inline-flex items-center gap-1 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 text-xs font-bold rounded-xl transition">
                                            <Icon icon="tabler:plus" class="w-4 h-4" />
                                            Agregar Fila
                                        </button>
                                        <button @click="saveDailyAgendaToServer" :disabled="savingAgenda" class="inline-flex items-center gap-1.5 px-4 py-1.5 bg-rose-600 hover:bg-rose-700 text-white text-xs font-bold rounded-xl transition shadow-xs disabled:opacity-50">
                                            <Icon icon="tabler:device-floppy" class="w-4 h-4" />
                                            {{ savingAgenda ? 'Guardando...' : 'Guardar Agenda' }}
                                        </button>
                                    </div>
                                </div>

                                <!-- Tabla Estilo Libreta Escolar -->
                                <div class="border border-purple-200 dark:border-purple-900/50 rounded-2xl overflow-hidden shadow-xs">
                                    <table class="w-full text-left text-xs">
                                        <thead class="bg-purple-50 dark:bg-purple-950/40 text-purple-900 dark:text-purple-300 font-extrabold uppercase tracking-wider border-b border-purple-200 dark:border-purple-900/50">
                                            <tr>
                                                <th class="py-3 px-3 w-12 text-center">#</th>
                                                <th class="py-3 px-4 w-1/4">SUBJECT (Curso)</th>
                                                <th class="py-3 px-4 w-1/2">TOPICS (Tema del día)</th>
                                                <th class="py-3 px-4 w-1/4">HOME WORKS (Tareas)</th>
                                                <th class="py-3 px-2 w-10 text-center"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-purple-100 dark:divide-purple-950/40 bg-white dark:bg-slate-900 font-medium">
                                            <tr v-for="(row, idx) in agendaRows" :key="idx" class="hover:bg-purple-50/30 dark:hover:bg-purple-950/20 transition">
                                                <td class="py-2.5 px-3 text-center text-slate-400 font-bold">
                                                    {{ idx + 1 }}
                                                </td>
                                                <td class="py-2.5 px-4">
                                                    <input type="text" v-model="row.course_name" placeholder="Ej. Álgebra, Comunicación..." class="w-full text-xs font-bold text-purple-950 dark:text-purple-200 bg-transparent border-0 border-b border-dashed border-slate-300 dark:border-slate-700 focus:ring-0 focus:border-rose-500 py-1 px-0" />
                                                </td>
                                                <td class="py-2.5 px-4">
                                                    <textarea v-model="row.topic" rows="2" placeholder="Tema desarrollado hoy (obtenido del temario o escribir aquí)..." class="w-full text-xs text-slate-700 dark:text-slate-200 bg-transparent border-0 border-b border-dashed border-slate-300 dark:border-slate-700 focus:ring-0 focus:border-rose-500 py-1 px-0 resize-y"></textarea>
                                                </td>
                                                <td class="py-2.5 px-4">
                                                    <div class="flex items-center gap-2 mb-1.5">
                                                        <button type="button" @click="row.has_homework = false" :class="!row.has_homework ? 'bg-slate-700 text-white font-extrabold' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'" class="px-2.5 py-0.5 rounded-lg text-[11px] uppercase transition">
                                                            NO
                                                        </button>
                                                        <button type="button" @click="row.has_homework = true" :class="row.has_homework ? 'bg-rose-600 text-white font-extrabold' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'" class="px-2.5 py-0.5 rounded-lg text-[11px] uppercase transition">
                                                            SÍ
                                                        </button>
                                                    </div>
                                                    <input v-if="row.has_homework" type="text" v-model="row.homework" placeholder="Detalle de la tarea para la casa..." class="w-full text-xs text-rose-600 dark:text-rose-400 font-semibold bg-rose-50/50 dark:bg-rose-950/20 border border-rose-200 dark:border-rose-900/50 rounded-lg py-1 px-2 focus:ring-rose-500" />
                                                </td>
                                                <td class="py-2.5 px-2 text-center">
                                                    <button @click="removeAgendaRow(idx)" class="text-slate-400 hover:text-rose-600 transition p-1" title="Eliminar fila">
                                                        <Icon icon="tabler:trash" class="w-4 h-4" />
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="agendaRows.length === 0">
                                                <td colspan="5" class="py-8 text-center text-slate-400 italic">
                                                    No hay cursos programados para hoy en el horario. Pulsa "Agregar Fila" o configura el horario del aula.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- PARTE INFERIOR: REGISTRO INDIVIDUAL POR ESTUDIANTE (ASISTENCIA, OBSERVACIONES, MÉRITOS Y DEMÉRITOS) -->
                            <div class="card-premium">
                                <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
                                    <div class="flex items-center gap-2.5">
                                        <div class="p-2 bg-indigo-500/10 text-indigo-600 rounded-xl">
                                            <Icon icon="tabler:users" class="w-5 h-5" />
                                        </div>
                                        <div>
                                            <h3 class="font-bold text-base text-slate-800 dark:text-white">Reporte Individual por Estudiante (Parte Inferior de la Agenda)</h3>
                                            <p class="text-xs text-slate-500 dark:text-slate-400">Asistencia, observaciones, méritos y deméritos registrados por cada profesor en su curso</p>
                                        </div>
                                    </div>
                                    <span class="text-xs font-bold text-slate-400 bg-slate-100 dark:bg-slate-800 px-3 py-1 rounded-full">
                                        {{ agendaStudents.length }} Estudiantes
                                    </span>
                                </div>

                                <div class="overflow-x-auto">
                                    <table class="w-full text-left text-xs border-collapse">
                                        <thead>
                                            <tr class="border-b border-slate-200 dark:border-slate-800 text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider text-[11px]">
                                                <th class="py-3 px-3 w-10 text-center">#</th>
                                                <th class="py-3 px-3">Estudiante</th>
                                                <th class="py-3 px-3 w-36 text-center">Asistencia del Día</th>
                                                <th class="py-3 px-4">Observaciones de Docentes</th>
                                                <th class="py-3 px-4 w-44">Deméritos (Falta / Código)</th>
                                                <th class="py-3 px-4 w-44">Méritos</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60">
                                            <tr v-for="(stu, sIdx) in agendaStudents" :key="stu.id_student" class="hover:bg-slate-50 dark:hover:bg-slate-800/30 transition">
                                                <td class="py-3 px-3 text-center text-slate-400 font-bold">
                                                    {{ sIdx + 1 }}
                                                </td>
                                                <td class="py-3 px-3 font-bold text-slate-800 dark:text-slate-100">
                                                    {{ stu.apellidos }}, {{ stu.nombres }}
                                                </td>
                                                <td class="py-3 px-3 text-center">
                                                    <!-- Sello estilo stamp del cuaderno físico -->
                                                    <span :class="getStudentAttendanceLabel(stu.id_student).color" class="inline-block px-3 py-1 rounded-xl font-extrabold text-[11px] border tracking-wider uppercase">
                                                        {{ getStudentAttendanceLabel(stu.id_student).text }}
                                                    </span>
                                                </td>
                                                <td class="py-3 px-4">
                                                    <div v-if="getStudentRecordsForDay(stu.id_student).filter(r => r.observations).length > 0" class="space-y-1">
                                                        <div v-for="(rec, rIdx) in getStudentRecordsForDay(stu.id_student).filter(r => r.observations)" :key="rIdx" class="text-xs text-slate-700 dark:text-slate-300">
                                                            <span class="font-bold text-indigo-600 dark:text-indigo-400">[{{ rec.course ? rec.course.label : 'Curso' }}]:</span>
                                                            <span class="ml-1">{{ rec.observations }}</span>
                                                        </div>
                                                    </div>
                                                    <span v-else class="text-slate-400 italic text-[11px]">Sin observaciones hoy</span>
                                                </td>
                                                <td class="py-3 px-4">
                                                    <div v-if="getStudentRecordsForDay(stu.id_student).filter(r => r.demerit_code || r.demerits).length > 0" class="space-y-1">
                                                        <div v-for="(rec, rIdx) in getStudentRecordsForDay(stu.id_student).filter(r => r.demerit_code || r.demerits)" :key="rIdx" class="p-1.5 rounded-xl bg-rose-500/10 border border-rose-500/20 text-rose-700 dark:text-rose-400 text-xs">
                                                            <span class="font-extrabold text-[10px] uppercase block">
                                                                {{ rec.demerit_code || 'DEMÉRITO' }} ({{ rec.course ? rec.course.label : '' }})
                                                            </span>
                                                            <span class="text-[11px]">{{ rec.demerits || rec.observations }}</span>
                                                        </div>
                                                    </div>
                                                    <span v-else class="text-slate-400 text-[11px]">—</span>
                                                </td>
                                                <td class="py-3 px-4">
                                                    <div v-if="getStudentRecordsForDay(stu.id_student).filter(r => r.merit_code || r.merits).length > 0" class="space-y-1">
                                                        <div v-for="(rec, rIdx) in getStudentRecordsForDay(stu.id_student).filter(r => r.merit_code || r.merits)" :key="rIdx" class="p-1.5 rounded-xl bg-emerald-500/10 border border-emerald-500/20 text-emerald-700 dark:text-emerald-400 text-xs">
                                                            <span class="font-extrabold text-[10px] uppercase block">
                                                                {{ rec.merit_code || 'MÉRITO' }} ({{ rec.course ? rec.course.label : '' }})
                                                            </span>
                                                            <span class="text-[11px]">{{ rec.merits }}</span>
                                                        </div>
                                                    </div>
                                                    <span v-else class="text-slate-400 text-[11px]">—</span>
                                                </td>
                                            </tr>
                                            <tr v-if="agendaStudents.length === 0">
                                                <td colspan="6" class="py-6 text-center text-slate-400 italic">
                                                    No hay estudiantes registrados en esta aula.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Alumnos lista -->
                        <div v-if="mainTab == 1" class="card-premium">
                            <div class="grid gap-3">
                                <div class="p-3 pb-0">
                                    <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                    <!-- refreshList(['students', 'datalist'])  o @click="listarStudent(classroom.id)"-->
                                </div>

                                <!-- mdiGraphql para icono de grafo -->
                                <div class="max-h-[600px] overflow-y-auto">
                                    <!-- Lista de estudiantes -->
                                    <CardBox v-if="arrayStudents.length" has-table><!-- students.length -->
                                        <!-- Tablesingle opciones: checkable -->
                                        <TableAdvanced modulo="estudiante" :modulos="'Aula ' + classroom.label" :data="arrayStudents" :fields="arrayStudentCol" ruta="student" exporteable noSearch noPaginate showIndex :numberItems="50" :checkable="(canWrite && !isSecre ? true : false)" changeSelect1 titleSelect1="EAP" :select1="arrayEAPs" :originId="classroom.id" originType="classroom" printLine labelprint1="libreta" @emitPromedios="studentPromedios($event)" /><!-- @confirm="refreshStudents" visualable checkable -->
                                    </CardBox>
                                    <CardBox v-else>
                                        <CardBoxComponentEmpty />
                                    </CardBox>
                                </div>
                            </div>
                        </div>

                        <!-- Alumnos asistencia, se quita canWrite pues tutores y coordinadores pueden hacer cambios a esta sección -->
                        <div v-if="mainTab == 2 && !isPsico && !isSecre" class="card-premium">
                            <div class="grid gap-3">
                                <div class="p-3 pb-0 grid gap-3">
                                    <div v-if="!arrayDiarios.length" class="flex flex-wrap justify-start gap-3">
                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar asistencia" @click.once="iniciarAsistencia(fechaConsulta)" class="inline-block" />
                                        <!-- <BaseButton :icon="mdiRefresh" color="info"
                                                icon-size="20" small label="Refresh" @click="refreshList(['asistencias'])"/> -->
                                        <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                    </div>
                                    <div v-else class="grid gap-3">
                                        <div class="flex flex-wrap gap-3">
                                            <BaseButton :icon="mdiPlusCircle" color="info" whitespaceNormal icon-size="20" small label="Iniciar registro de asistencia que falta" @click.once="iniciarAsistencia(fechaConsulta)" class="inline-block" />
                                            <!-- <BaseButton :icon="mdiRefresh" color="info"
                                                    icon-size="20" small label="Refresh" @click="refreshList(['asistencias'])"/> -->
                                            <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                        </div>
                                        <div>
                                            <li>Las observaciones se compartirá entre todos los cursos.</li>
                                            <li>La asistencia y las observaciones se mostrará en la agenda del alumno (Presione el botón guardar si realiza algún cambio).</li>
                                        </div>
                                        <div class="items-center flex flex-col lg:flex-row gap-3">

                                            <div class="text-gray-800 lg:text-base text-sm font-semibold lg:mr-3">{{ 'Bimestre ' + bimestreConsultaDiarios + ' - Fecha: ' }}</div>
                                            <div>
                                                <input class="" type="date" v-model="fechaConsulta" @change="listarAsistencia(fechaConsulta)">
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <table v-if="arrayDiarios.length" class="table-responsive">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Estudiante</th>
                                            <th>Asistencia</th>
                                            <th>Observación (general)
                                                <span>
                                                    <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" title="Esta información de compartirá para todos los cursos">
                                                        <BaseIcon :path="mdiInformationOutline" size="15" />

                                                        <span class="font-light absolute hidden group-hover:flex -left-5 -top-2 -translate-y-full w-64 px-2 py-1 bg-gray-700 rounded-lg text-center text-white text-sm after:content-[''] after:absolute after:left-1/2 after:top-[100%] after:-translate-x-1/2 after:border-8 after:border-x-transparent after:border-b-transparent after:border-t-gray-700">
                                                            Esta información de compartirá para todos los cursos
                                                        </span>
                                                    </a>
                                                </span>
                                            </th>
                                            <!-- <th width="100">Conducta</th> -->
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                        <tr v-for="(diario, index) in arrayDiarios" :key="diario.id">
                                            <td data-label="#">{{ index + 1 }}</td>
                                            <td class="flex justify-start lg:table-cell bg-gray-100 lg:bg-transparent" data-label="Estudiante">
                                                {{ diario.apellidos + ' ' + diario.nombres }}

                                            </td>
                                            <td class="flex justify-start lg:table-cell" data-label="Asistencia">
                                                <div class="grid lg:flex lg:flex-row">
                                                    <div class="flex items-center mr-4 radio-clean radio-green">
                                                        <input :id="'radio-a' + diario.id" type="radio" value="1" v-model="diario.asistencia" :name="'n-radio' + diario.id" @change="updateDiario(diario.id, diario.asistencia, diario.content)"><!-- checked -->
                                                        <label :for="'radio-a' + diario.id" class="after:!content-none">Asistencia</label>
                                                    </div>
                                                    <div class="flex items-center mr-4 radio-clean radio-red">
                                                        <input :id="'radio-f' + diario.id" type="radio" value="0" v-model="diario.asistencia" :name="'n-radio' + diario.id" @change="updateDiario(diario.id, diario.asistencia, diario.content)">
                                                        <label :for="'radio-f' + diario.id" class="after:!content-none">Falta</label>
                                                    </div>
                                                    <div class="flex items-center mr-4 radio-clean radio-red" title="Falta Justificada">
                                                        <input :id="'radio-fj' + diario.id" type="radio" value="3" v-model="diario.asistencia" :name="'n-radio' + diario.id" @change="updateDiario(diario.id, diario.asistencia, diario.content)">
                                                        <label :for="'radio-fj' + diario.id" class="after:!content-none">Falta J.</label>
                                                    </div>
                                                    <div class="flex items-center mr-4 radio-clean radio-yellow">
                                                        <input :id="'radio-t' + diario.id" type="radio" value="2" v-model="diario.asistencia" :name="'n-radio' + diario.id" @change="updateDiario(diario.id, diario.asistencia, diario.content)">
                                                        <label :for="'radio-t' + diario.id" class="after:!content-none">Tardanza</label>
                                                    </div>
                                                    <div class="flex items-center mr-4 radio-clean radio-yellow" title="Tardanza Justificada">
                                                        <input :id="'radio-tj' + diario.id" type="radio" value="4" v-model="diario.asistencia" :name="'n-radio' + diario.id" @change="updateDiario(diario.id, diario.asistencia, diario.content)">
                                                        <label :for="'radio-tj' + diario.id" class="after:!content-none">Tardanza J.</label>
                                                    </div>
                                                </div>
                                                <!-- Marc {{ diario.asistencia }} -->

                                            </td>
                                            <td class="lg:table-cell grid" data-label="Observaciones">
                                                <input type="text" v-model="diario.content" title="Esta información se compartirá en todas los cursos del día">
                                                <!-- <BaseButton :icon="mdiContentSave" color="info" class="ml-2"
                                                    icon-size="20" small label="Guardar" @change="updateDiario(diario.id, diario.asistencia, diario.content)"/> -->
                                                <!-- Obs {{ diario.content }} -->
                                            </td>
                                            <!-- <td class="lg:table-cell grid" data-label="Conducta">
                                                    <input type="text" v-model="diario.calification_conducta" title="Nota de conducta">
                                                </td> -->
                                            <td class="flex lg:table-cell" colspan="6">
                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                    <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto , diario.calification_conducta -->

                                                    <BaseButton color="info" :icon="mdiContentSave" small @click="updateDiario(diario.id, diario.asistencia, diario.content)" />

                                                </BaseButtons>

                                            </td>
                                            <td data-label="Log" @click="showLog = !showLog">
                                                <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                <span class="text-xs" v-if="showLog">Modif. {{ diario.nombre_usuario }} {{ diario.updated_at ? formatDateTime(diario.updated_at) : '' }}</span>
                                            </td>
                                        </tr>

                                        <!-- <tr>
                                                <td class="flex lg:table-cell" colspan="3">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info"
                                                            icon-size="20" small label="Guardar" />
                                                    </div>
                                                </td>
                                            </tr> -->
                                    </tbody>
                                </table>
                                <p v-else class="p-3 pt-0">
                                    Iniciar asistencia, marcar todos como presentes (Asistencia), click en Refresh si no ve la lista luego de iniciar la asistencia ...
                                </p>
                            </div>
                        </div>

                        <!-- Conducta -->
                        <div v-if="mainTab == 3 && !isPsico && !isSecre" class="card-premium">
                            <div v-if="!arrayConductas.length" class="grid gap-3 p-3">
                                <div class="flex flex-wrap gap-3 justify-start">
                                    <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar calificación de conducta" @click.once="iniciarConducta(semanaConsulta, bimestreConsulta)" class="inline-block" />

                                    <!-- <BaseButton :icon="mdiRefresh" color="info"
                                                    icon-size="20" small label="Refresh" @click="refreshList(['asistencias'])"/> -->
                                    <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                </div>
                                <div>
                                    <li>Semana actual ({{ semanaActual }}). Bimestre actual ({{ refCicloActual }}).</li>

                                </div>
                            </div>
                            <div v-else class="w-full flex flex-wrap p-3 gap-3">
                                <BaseButton :icon="mdiPlusCircle" color="info" whitespaceNormal icon-size="20" class="inline-block" small label="Iniciar registro de conducta que falta" @click.once="iniciarConducta(semanaConsulta, bimestreConsulta)" />
                                <!-- <BaseButton :icon="mdiRefresh" color="info"
                                                    icon-size="20" small label="Refresh" @click="refreshList(['asistencias'])"/> -->
                                <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />

                            </div>
                            <div class="flex justify-between items-center">
                                <button type="button" class="p-1 py-1 text-center text-black bg-white-500 rounded-lg hover:bg-white-700 focus:ring-4 focus:outline-none focus:ring-white-300 h-9 w-9 flex items-center justify-center" @click="listarConductas((parseInt(semanaConsulta) - 1))">
                                    <BaseIcon :path="mdiChevronLeft" :size="20" />
                                </button>
                                <div class="flex gap-3 items-center">
                                    <h1 class="text-gray-800 lg:text-base text-sm font-semibold">{{ 'Bimestre ' + bimestreConsulta + ' - Semana ' }}</h1> <input class="text-lg w-12" type="text" v-model="semanaConsulta" @keyup.enter="listarConductas(semanaConsulta)">
                                </div>
                                <button type="button" class="p-1 py-1 text-center text-black bg-white-500 rounded-lg hover:bg-white-700 focus:ring-4 focus:outline-none focus:ring-white-300 h-9 w-9 flex items-center justify-center" @click="listarConductas((parseInt(semanaConsulta) + 1))">
                                    <BaseIcon :path="mdiChevronRight" :size="20" />
                                </button>
                            </div>

                            <table v-if="arrayConductas.length" class="table-responsive">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Estudiante</th>
                                        <th>Bimestre</th>
                                        <th>Semana</th>
                                        <th>Nota Conducta</th>
                                        <th>Obervación</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                    <tr v-for="(conducta, index) in arrayConductas" :key="conducta.id">
                                        <td>{{ index + 1 }}</td>
                                        <td class="bg-gray-100 lg:bg-transparent" data-label="Estudiante">
                                            {{ conducta.apellidos + ' ' + conducta.nombres }}

                                        </td>
                                        <td class="text-center" data-label="Bimestre">
                                            {{ conducta.ref_ciclo }}
                                            <!-- <input type="text" v-model="conducta.ref_ciclo" title="Bimestre"> -->
                                        </td>
                                        <td class="text-center" data-label="Semana">
                                            {{ conducta.semana }}
                                            <!-- <input type="text"  v-model="conducta.semana" title="Semana"> -->
                                        </td>
                                        <td class="text-center lg:w-40" data-label="Calificación">
                                            <input type="text" class="inline-block focusNextConducta lg:w-full" v-model="conducta.calification_conducta" title="Calificación de conducta" @focus="$event.target.select()" :tabindex="200 + index">
                                        </td>
                                        <td class="lg:table-cell xl:w-96" data-label="Observaciones">
                                            <input type="text" v-model="conducta.content" title="Alguna observación" class="xl:w-full">
                                            <!-- <BaseButton :icon="mdiContentSave" color="info" class="ml-2"
                                                    icon-size="20" small label="Guardar" @change="updateDiario(conducta.id, conducta.asistencia, conducta.content)"/> -->
                                            <!-- Obs {{ conducta.content }} -->
                                        </td>
                                        <!-- <td class="lg:table-cell grid" data-label="Conducta">
                                                    <input type="text" v-model="conducta.calification_conducta" title="Nota de conducta">
                                                </td> -->
                                        <td class="flex lg:table-cell" colspan="6">
                                            <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto , conducta.calification_conducta -->

                                                <BaseButton name="buttonssave-conducta" color="info" :icon="mdiContentSave" small @click="updateConducta(conducta.id, conducta.calification_conducta, conducta.content)" />

                                            </BaseButtons>

                                        </td>
                                        <td data-label="Log" @click="showLog = !showLog">
                                            <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                            <span class="text-xs" v-if="showLog">Modif. {{ conducta.nombre_usuario }} {{ conducta.updated_at ? formatDateTime(conducta.updated_at) : '' }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="flex lg:table-cell" colspan="6">
                                            <div class="w-full flex justify-end">
                                                <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayConductas()" /><!-- <-- Cambiar Bimestre -->
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- <tr>
                                                <td class="flex lg:table-cell" colspan="3">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info"
                                                            icon-size="20" small label="Guardar" />
                                                    </div>
                                                </td>
                                            </tr> -->
                                </tbody>
                            </table>
                            <p v-else class="p-4">
                                Iniciar conducta semanal, nota por defecto 18, click en Refresh si no ve la lista luego de iniciar ...
                            </p>
                        </div>

                        <!-- Informe de evolución -->
                        <div v-if="mainTab == 4 && !isPsico && !isSecre" class="card-premium">
                            <div class="p-3">
                                <BaseIcon :path="mdiInformationOutline" size="15" /> Puede registrar informe de evolución si fuera necesario, estos pueden estar realacionados a las compentencias o alguna especialidad a desarrollar por el estudiante. A su consideración puede definir los objetivos, logros o recomendaciones. Revise si esta tabla de competencias son correctas antes de iniciar el informe.
                            </div>
                            <div class="mb-4 overflow-auto max-h-[350px]">
                                <table v-if="competencias.length" class="table-basic">
                                    <thead>
                                        <tr>
                                            <th colspan="4">Competencias de este ciclo curricular</th>
                                        </tr>
                                        <tr>
                                            <th>#</th>
                                            <th>Competencia</th>
                                            <th>Área</th>
                                            <th>Descripción</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(competencia, index) in competencias" :key="competencia.id">
                                            <td data-label="#" :title="competencia.id"> {{ index + 1 }}</td>
                                            <td data-label="Competencia">
                                                <div class="min-w-[450px]">{{ competencia.label }}</div>
                                            </td>
                                            <td data-label="Área"> {{ competencia.label_area }}</td>
                                            <td data-label="Descripción"> {{ competencia.description }}</td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto -->
                            <!-- INit row tarea -->
                            <div class="tab-interno">
                                <button @click="(tabEvoInforme = 0), listarEvolucionInforme(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" class="tab-interno-btn" :class="[tabEvoInforme == 0 ? 'active' : 'inactivo']">
                                    Primer bimestre
                                </button>
                                <button @click="(tabEvoInforme = 1), listarEvolucionInforme(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" class="tab-interno-btn" :class="[tabEvoInforme == 1 ? 'active' : 'inactivo']">
                                    Segundo bimestre
                                </button>
                                <button @click="(tabEvoInforme = 2), listarEvolucionInforme(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" class="tab-interno-btn" :class="[tabEvoInforme == 2 ? 'active' : 'inactivo']">
                                    Tercer bimestre
                                </button>

                                <button @click="(tabEvoInforme = 3), listarEvolucionInforme(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" class="tab-interno-btn" :class="[tabEvoInforme == 3 ? 'active' : 'inactivo']">
                                    Cuarto bimestre
                                </button>
                            </div>
                            <div v-if="tabEvoInforme >= 0">
                                <div class="grid gap-3 p-3">


                                    <div v-if="competencias.length && (canWrite || canWriteInforme)">
                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar informes" @click.once="iniciarEvolucionInforme(confGlobal.value.CICLO_ANIO_ESCOLAR + (tabEvoInforme == 0 ? 'B1' : (tabEvoInforme == 1 ? 'B2' : (tabEvoInforme == 2 ? 'B3' : (tabEvoInforme == 3 ? 'B4' : '')))))" />
                                        <!-- <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                                icon-size="20" small label="Refresh" @click="refreshList(['evolucion_informes'])"/> -->
                                        <BaseButton :icon="mdiRefresh" color="info" class="ml-4" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                    </div>
                                    <div>
                                        Si no ve el cambio al iniciar o actualizar un registro click en Refresh.
                                    </div>
                                    <table v-if="arrayEvolucionInformes.length" class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Estudiante</th>
                                                <th>Bimestre</th>
                                                <th>Actualizado por</th>
                                                <th>Última Modif.</th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(informe, index) in arrayEvolucionInformes" :key="informe.id">
                                                <td data-label="#" :title="informe.id"> {{ index + 1 }}</td>
                                                <td data-label="Nombre"> {{ informe.apellidos }} {{ informe.nombres }}</td>
                                                <td data-label="Bimestre"> {{ informe.ref_ciclo }}</td>
                                                <td data-label="Actualizado por"> {{ informe.nombre_usuario }}</td>
                                                <td data-label="Última Modif."> {{ informe.updated_at ? formatDateTime(informe.updated_at) : '' }}</td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                        <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                        <BaseButton v-if="!canWrite" color="info" :icon="mdiEye" @click="initModal(informe.id, 'leer', informe)" />
                                                        <BaseButton v-if="canWrite || canWriteInforme" color="warning" :icon="mdiPencil" small @click="initModal(informe.id, 'actualizar', informe)" />
                                                        <template v-if="canWrite || canWriteInforme">
                                                            <BaseButton v-if="informe.status" color="success" :icon="mdiCheckCircle" small @click="initModal(informe.id, 'borrador')" title="Enviado a Libreta" />
                                                            <BaseButton v-else color="contrast" :icon="mdiCloseCircle" small @click="initModal(informe.id, 'publicar')" title="Borrador" />
                                                        </template>

                                                        <!-- <BaseButton
                                                                v-if="canWrite"
                                                                color="danger"
                                                                :icon="mdiTrashCan"
                                                                small
                                                                @click="initModal(informe.id, 'eliminar')"
                                                            /> -->
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                            <tr v-if="canWrite">
                                                <td class="flex lg:table-cell" colspan="5">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info" label="Enviar todo a la libreta" icon-size="20" small @click="changeAllStatus(confGlobal.value.CICLO_ANIO_ESCOLAR + (tabEvoInforme == 0 ? 'B1' : (tabEvoInforme == 1 ? 'B2' : (tabEvoInforme == 2 ? 'B3' : (tabEvoInforme == 3 ? 'B4' : '')))))" />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- <p v-else class="p-4">
                                        Sin informes registrados
                                    </p> -->
                            <div class="p-3" v-if="tabEvoInforme == -1">
                                Click al bimestre para mostrar el listado ⤴
                            </div>
                        </div>

                        <!-- Tareas -->


                        <!-- Guías de estudio -->

                        <!-- Listado de calificaciones -->
                        <div v-if="mainTab == 5 && !isPsico" class="card-premium">

                            <div class="tab-interno">
                                <button @click="(tabCalif = 0), listarCalification(classroom.id, confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" class="tab-interno-btn" :class="[tabCalif == 0 ? 'active' : 'inactivo']">
                                    Primer bimestre
                                </button>
                                <button @click="(tabCalif = 1), listarCalification(classroom.id, confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" class="tab-interno-btn" :class="[tabCalif == 1 ? 'active' : 'inactivo']">
                                    Segundo bimestre
                                </button>
                                <button @click="(tabCalif = 2), listarCalification(classroom.id, confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" class="tab-interno-btn" :class="[tabCalif == 2 ? 'active' : 'inactivo']">
                                    Tercer bimestre
                                </button>

                                <button @click="(tabCalif = 3), listarCalification(classroom.id, confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" class="tab-interno-btn" :class="[tabCalif == 3 ? 'active' : 'inactivo']">
                                    Cuarto bimestre
                                </button>
                                <!--- Consolidado son parámetros distintos -->
                                <button @click="(tabCalif = 4), listarCalification(classroom.id, '', 1)" class="tab-interno-btn" :class="[tabCalif == 4 ? 'active' : 'inactivo']">
                                    Consolidado
                                </button>
                            </div>

                            <!-- Entre bimestres cambian 4 variables 2 de inicio 1 de guardar y otro de guardar todo-->

                            <!-- Primer Bimestre -->
                            <div v-if="tabCalif >= 0 && tabCalif < 4" class="p-3 grid gap-3">

                                <div>
                                    <li>Se muestran los promedios antes del simulacro, es decir, sin el puntaje adicional si lo tuviera.</li>
                                    <li>La columna Puntaje es el puntaje del examen de admisión de ese periodo.</li>
                                </div>
                                <div>
                                    <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                    <!-- refreshList(['students', 'datalist'])  o @click="listarStudent(classroom.id)"-->
                                </div>


                                <!-- Lista de estudiantes -->
                                <CardBox v-if="arrayCalification.length" has-table><!-- students.length -->
                                    <!-- Tablesingle opciones: checkable -->
                                    <div class="w-full overflow-x-auto">
                                        <TableAdvanced modulo="calification" :modulos="'Calificaciones ' + classroom.label" :data="arrayCalification" :fields="arrayCalificationCol" ruta="calification" exporteable noSearch noPaginate showIndex :numberItems="100" :originId="classroom.id" originType="classroom" /><!-- @confirm="refreshStudents" visualable checkable -->
                                    </div>

                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>

                            <div v-if="tabCalif == 4" class="p-3 grid gap-3">
                                <div>
                                    <li>Se muestran los promedios antes del simulacro, es decir, sin el puntaje adicional si lo tuviera.</li>
                                    <li>La columna Puntaje es el puntaje del examen de admisión de ese periodo.</li>
                                </div>
                                <div>
                                    <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroom-collaborator', { 'id_classroom': classroom.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                    <!-- refreshList(['students', 'datalist'])  o @click="listarStudent(classroom.id)"-->
                                </div>

                                <!-- Lista de estudiantes -->
                                <CardBox v-if="arrayCalificationConsolidado.length" has-table><!-- students.length -->
                                    <!-- Tablesingle opciones: checkable -->
                                    <div class="w-full overflow-x-auto">
                                        <TableAdvanced modulo="calification" :modulos="'Calificaciones ' + classroom.label" :data="arrayCalificationConsolidado" :fields="arrayCalificationCol" ruta="calification" exporteable noSearch noPaginate showIndex :numberItems="100" :originId="classroom.id" originType="classroom" /><!-- @confirm="refreshStudents" visualable checkable -->
                                    </div>

                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>

                            <div class="p-3" v-if="tabCalif == -1">
                                Click al bimestre para mostrar el listado ⤴
                            </div>


                            <!-- <div v-if="tabCalif==1">
                                        
                                    </div>

                                    
                                    <div v-if="tabCalif==2">
                                        
                                    </div>

                                    
                                    <div v-if="tabCalif==3">
                                        
                                    </div> -->

                        </div>

                        <!-- Puntaje de admisión -->
                        <div v-if="mainTab == 6 && confGlobal.value.ACADEMICO_USE_SIMULACRO_ADMISION == 1 && !isPsico && !isSecre" class="card-premium">
                            <div class="tab-interno">
                                <button @click="(tabPuntaje = 0), listarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" class="tab-interno-btn" :class="[tabPuntaje == 0 ? 'active' : 'inactivo']">
                                    Primer bimestre
                                </button>
                                <button @click="(tabPuntaje = 1), listarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" class="tab-interno-btn" :class="[tabPuntaje == 1 ? 'active' : 'inactivo']">
                                    Segundo bimestre
                                </button>
                                <button @click="(tabPuntaje = 2), listarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" class="tab-interno-btn" :class="[tabPuntaje == 2 ? 'active' : 'inactivo']">
                                    Tercer bimestre
                                </button>

                                <button @click="(tabPuntaje = 3), listarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" class="tab-interno-btn" :class="[tabPuntaje == 3 ? 'active' : 'inactivo']">
                                    Cuarto bimestre
                                </button>
                            </div>

                            <!-- Entre bimestres cambian 4 variables 2 de inicio 1 de guardar y otro de guardar todo-->

                            <!-- Primer Bimestre -->
                            <div v-if="tabPuntaje == 0">
                                <div v-if="!arrayAdmisionPuntajes.length">
                                    <div class="w-full flex justify-start mt-4 ml-4">
                                        <template v-if="canWrite">
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar registro de puntajes" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" /><!-- <-- Cambiar Bimestre -->
                                        </template>
                                    </div>
                                    <div class="p-4">
                                        <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar el registro de puntajes de admisión todas se guardan inicialmente con vacío lo cual da un resultado ausente.
                                    </div>
                                </div>
                                <div v-if="arrayAdmisionPuntajes.length">
                                    <div v-if="canWrite && arrayAdmisionPuntajes.length != students.length" class="p-4">
                                        <div class="mb-2 text-red-600">
                                            <li>La cantidad de registros de puntajes is distinta a la lista de alumnos de esta aula.</li>
                                            <li>Click en añadir registro de puntaje faltante para crear el registro del alumno que falta, a menos que sepa que esta lista es correcta (ej. alumnos retirados, etc.).</li>
                                        </div>
                                        <div>
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Añadir registro de puntaje faltante" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" /><!-- <-- Cambiar Bimestre -->
                                        </div>
                                    </div>
                                    <p class="p-4">
                                        <li> El puntaje máximo para este nivel es {{ puntajeMaximo }} y el mínimo es {{ puntajeMinimo }}</li>
                                        <li> Puede pasar a la siguiente fila de la misma columna presionando TAB o ENTER.</li>
                                    </p>
                                    <table class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Alumno</th>
                                                <th class="text-center" title="Puntaje">Puntaje.</th>
                                                <th class="text-center" title="Resultado">Resultado.</th>

                                                <th v-if="canWrite" class="text-center" title="Actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                            <tr v-for="(cal, index) in arrayAdmisionPuntajes" :key="cal.id">
                                                <td data-label="#" :title="cal.id">{{ index + 1 }}</td>
                                                <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                    {{ cal.apellidos + ' ' + cal.nombres }}
                                                </td>
                                                <td class="text-center no-number before:flex before:items-center" data-label="Puntaje" :set="result_text = ''">

                                                    <span v-if="!canWrite || closeB1">{{ cal.puntaje }}</span>
                                                    <input type="number" v-else v-model="cal.puntaje" class="inline-block focusNext w-24 lg:w-32 focusNext" :class="(cal.puntaje < parseInt(puntajeMinimo) || cal.puntaje > puntajeMaximo ? 'text-red-600' : '')" @focus="$event.target.select()" :tabindex="100 + index">
                                                    <!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                </td>

                                                <td class="text-center" :class="(cal.resultado < 1 ? 'text-red-600' : (cal.resultado == 1 ? 'text-green-600' : ''))" data-label="Resultado" :set="(cal.puntaje >= parseInt(puntajeMinimo) ? cal.resultado = 1 : (cal.puntaje > 0 && cal.puntaje < parseInt(puntajeMinimo) ? cal.resultado = 0 : cal.resultado = 2))" :title="cal.resultado">

                                                    <span>{{ (cal.resultado == 1 ? 'Aprobado' : (cal.resultado == 2 ? 'Ausente' : 'Desaprobado')) }}</span>
                                                    <input type="hidden" v-model="cal.resultado">
                                                </td>

                                                <td v-if="canWrite" class="flex lg:table-cell" colspan="6">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>

                                                        <!-- <-- Cambiar Bimestre name -->
                                                        <BaseButton name="buttonssaveB1" color="info" :icon="mdiContentSave" small @click="updateAdmisionPuntaje(cal.id, 'actualizar', cal)" />

                                                    </BaseButtons>

                                                </td>
                                                <td data-label="Log" @click="showLog = !showLog">
                                                    <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                    <span class="text-xs" v-if="showLog">Modif. {{ cal.nombre_usuario }} {{ cal.updated_at ? formatDateTime(cal.updated_at) : '' }}</span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="flex lg:table-cell" colspan="6">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayAdmisionPuntajes('B1')" /><!-- <-- Cambiar Bimestre -->
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <!-- <p v-else class="p-4">
                                            Aun no se inicia las calificaciones
                                        </p> -->
                            </div>

                            <!-- Segundo Bimestre -->
                            <div v-if="tabPuntaje == 1">
                                <div v-if="!arrayAdmisionPuntajes.length">
                                    <div class="w-full flex justify-start mt-4 ml-4">
                                        <template v-if="canWrite">
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar registro de puntajes" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" />
                                        </template>
                                    </div>
                                    <div class="p-4">
                                        <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar el registro de puntajes de admisión todas se guardan inicialmente con vacío lo cual da un resultado ausente.
                                    </div>
                                </div>
                                <div v-if="arrayAdmisionPuntajes.length">
                                    <div v-if="canWrite && arrayAdmisionPuntajes.length != students.length" class="p-4">
                                        <div class="mb-2 text-red-600">
                                            <li>La cantidad de registros de puntajes es distinta a la lista de alumnos de esta aula.</li>
                                            <li>Click en añadir registro de puntaje faltante para crear el registro del alumno que falta, a menos que sepa que esta lista es correcta (ej. alumnos retirados, etc.).</li>
                                        </div>
                                        <div>
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Añadir registro de puntaje faltante" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" />
                                        </div>
                                    </div>
                                    <p class="p-4">
                                        <li> El punta máximo para este nivel es {{ puntajeMaximo }} y el mínimo es {{ puntajeMinimo }}</li>
                                        <li> Puede pasar a la siguiente fila de la misma columna presionando TAB o ENTER.</li>
                                    </p>
                                    <table class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Alumno</th>
                                                <th class="text-center" title="Puntaje">Puntaje.</th>
                                                <th class="text-center" title="Resultado">Resultado.</th>
                                                <th v-if="canWrite" class="text-center" title="Actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                            <tr v-for="(cal, index) in arrayAdmisionPuntajes" :key="cal.id">
                                                <td data-label="#" :title="cal.id">{{ index + 1 }}</td>
                                                <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                    {{ cal.apellidos + ' ' + cal.nombres }}
                                                </td>
                                                <td class="text-center no-number before:flex before:items-center" data-label="Puntaje" :set="result_text = ''">

                                                    <span v-if="!canWrite || closeB2">{{ cal.puntaje }}</span>
                                                    <input type="number" v-else v-model="cal.puntaje" class="inline-block focusNext w-24 lg:w-32 focusNext" :class="(cal.puntaje < parseInt(puntajeMinimo) || cal.puntaje > puntajeMaximo ? 'text-red-600' : '')" @focus="$event.target.select()" :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                </td>

                                                <td class="text-center" :class="(cal.resultado < 1 ? 'text-red-600' : (cal.resultado == 1 ? 'text-green-600' : ''))" data-label="Resultado" :set="(cal.puntaje >= parseInt(puntajeMinimo) ? cal.resultado = 1 : (cal.puntaje > 0 && cal.puntaje < parseInt(puntajeMinimo) ? cal.resultado = 0 : cal.resultado = 2))" :title="cal.resultado">

                                                    <span>{{ (cal.resultado == 1 ? 'Aprobado' : (cal.resultado == 2 ? 'Ausente' : 'Desaprobado')) }}</span>
                                                    <input type="hidden" v-model="cal.resultado">
                                                </td>

                                                <td v-if="canWrite" class="flex lg:table-cell" colspan="6">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>


                                                        <BaseButton name="buttonssaveB2" color="info" :icon="mdiContentSave" small @click="updateAdmisionPuntaje(cal.id, 'actualizar', cal)" />

                                                    </BaseButtons>

                                                </td>
                                                <td data-label="Log" @click="showLog = !showLog">
                                                    <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                    <span class="text-xs" v-if="showLog">Modif. {{ cal.nombre_usuario }} {{ cal.updated_at ? formatDateTime(cal.updated_at) : '' }}</span>
                                                </td>

                                            </tr>

                                            <tr>
                                                <td class="flex lg:table-cell" colspan="6">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayAdmisionPuntajes('B2')" />
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <!-- <p v-else class="p-4">
                                            Aun no se inicia las calificaciones
                                        </p> -->
                            </div>

                            <!-- Tercer Bimestre -->
                            <div v-if="tabPuntaje == 2">
                                <div v-if="!arrayAdmisionPuntajes.length">
                                    <div class="w-full flex justify-start mt-4 ml-4">
                                        <template v-if="canWrite">
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar registro de puntajes" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" />
                                        </template>
                                    </div>
                                    <div class="p-4">
                                        <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar el registro de puntajes de admisión todas se guardan inicialmente con vacío lo cual da un resultado ausente.
                                    </div>
                                </div>
                                <div v-if="arrayAdmisionPuntajes.length">
                                    <div v-if="canWrite && arrayAdmisionPuntajes.length != students.length" class="p-4">
                                        <div class="mb-2 text-red-600">
                                            <li>La cantidad de registros de puntajes es distinta a la lista de alumnos de esta aula.</li>
                                            <li>Click en añadir registro de puntaje faltante para crear el registro del alumno que falta, a menos que sepa que esta lista es correcta (ej. alumnos retirados, etc.).</li>
                                        </div>
                                        <div>
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Añadir registro de puntaje faltante" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" />
                                        </div>
                                    </div>
                                    <p class="p-4">
                                        <li> El punta máximo para este nivel es {{ puntajeMaximo }} y el mínimo es {{ puntajeMinimo }}</li>
                                        <li> Puede pasar a la siguiente fila de la misma columna presionando TAB o ENTER.</li>
                                    </p>
                                    <table class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Alumno</th>
                                                <th class="text-center" title="Puntaje">Puntaje.</th>
                                                <th class="text-center" title="Resultado">Resultado.</th>
                                                <th v-if="canWrite" class="text-center" title="Actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                            <tr v-for="(cal, index) in arrayAdmisionPuntajes" :key="cal.id">
                                                <td data-label="#" :title="cal.id">{{ index + 1 }}</td>
                                                <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                    {{ cal.apellidos + ' ' + cal.nombres }}
                                                </td>
                                                <td class="text-center no-number before:flex before:items-center" data-label="Puntaje" :set="result_text = ''">

                                                    <span v-if="!canWrite || closeB3">{{ cal.puntaje }}</span>
                                                    <input type="number" v-else v-model="cal.puntaje" class="inline-block focusNext w-24 lg:w-32 focusNext" :class="(cal.puntaje < parseInt(puntajeMinimo) || cal.puntaje > puntajeMaximo ? 'text-red-600' : '')" @focus="$event.target.select()" :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                </td>

                                                <td class="text-center" :class="(cal.resultado < 1 ? 'text-red-600' : (cal.resultado == 1 ? 'text-green-600' : ''))" data-label="Resultado" :set="(cal.puntaje >= parseInt(puntajeMinimo) ? cal.resultado = 1 : (cal.puntaje > 0 && cal.puntaje < parseInt(puntajeMinimo) ? cal.resultado = 0 : cal.resultado = 2))" :title="cal.resultado">

                                                    <span>{{ (cal.resultado == 1 ? 'Aprobado' : (cal.resultado == 2 ? 'Ausente' : 'Desaprobado')) }}</span>
                                                    <input type="hidden" v-model="cal.resultado">
                                                </td>
                                                <td v-if="canWrite" class="flex lg:table-cell" colspan="6">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <BaseButton name="buttonssaveB3" color="info" :icon="mdiContentSave" small @click="updateAdmisionPuntaje(cal.id, 'actualizar', cal)" />
                                                    </BaseButtons>

                                                </td>
                                                <td data-label="Log" @click="showLog = !showLog">
                                                    <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                    <span class="text-xs" v-if="showLog">Modif. {{ cal.nombre_usuario }} {{ cal.updated_at ? formatDateTime(cal.updated_at) : '' }}</span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="flex lg:table-cell" colspan="6">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayAdmisionPuntajes('B3')" />
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <!-- <p v-else class="p-4">
                                            Aun no se inicia las calificaciones
                                        </p> -->
                            </div>

                            <!-- Cuarto bimestre -->
                            <div v-if="tabPuntaje == 3">
                                <div v-if="!arrayAdmisionPuntajes.length">
                                    <div class="w-full flex justify-start mt-4 ml-4">
                                        <template v-if="canWrite">
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar registro de puntajes" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" /><!-- <-- Cambiar Bimestre -->
                                        </template>
                                    </div>
                                    <div class="p-4">
                                        <BaseIcon :path="mdiInformationOutline" size="15" /> Al iniciar el registro de puntajes de admisión todas se guardan inicialmente con vacío lo cual da un resultado ausente.
                                    </div>
                                </div>
                                <div v-if="arrayAdmisionPuntajes.length">
                                    <div v-if="canWrite && arrayAdmisionPuntajes.length != students.length" class="p-4">
                                        <div class="mb-2 text-red-600">
                                            <li>La cantidad de registros de puntajes es distinta a la lista de alumnos de esta aula.</li>
                                            <li>Click en añadir registro de puntaje faltante para crear el registro del alumno que falta, a menos que sepa que esta lista es correcta (ej. alumnos retirados, etc.).</li>
                                        </div>
                                        <div>
                                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Añadir registro de puntaje faltante" @click.once="iniciarAdmisionPuntaje(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" /><!-- <-- Cambiar Bimestre -->
                                        </div>
                                    </div>
                                    <p class="p-4">
                                        <li> El punta máximo para este nivel es {{ puntajeMaximo }} y el mínimo es {{ puntajeMinimo }}</li>
                                        <li> Puede pasar a la siguiente fila de la misma columna presionando TAB o ENTER.</li>
                                    </p>
                                    <table class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Alumno</th>
                                                <th class="text-center" title="Puntaje">Puntaje.</th>
                                                <th class="text-center" title="Resultado">Resultado.</th>
                                                <th v-if="canWrite" class="text-center" title="Actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                            <tr v-for="(cal, index) in arrayAdmisionPuntajes" :key="cal.id">
                                                <td data-label="#" :title="cal.id">{{ index + 1 }}</td>
                                                <td data-label="Alumno" class="bg-gray-100 lg:bg-transparent">
                                                    {{ cal.apellidos + ' ' + cal.nombres }}
                                                </td>
                                                <td class="text-center no-number before:flex before:items-center" data-label="Puntaje" :set="result_text = ''">

                                                    <span v-if="!canWrite || closeB4">{{ cal.puntaje }}</span>
                                                    <input type="number" v-else v-model="cal.puntaje" class="inline-block focusNext w-24 lg:w-32 !py-1" :class="(cal.puntaje < parseInt(puntajeMinimo) || cal.puntaje > puntajeMaximo ? 'text-red-600' : '')" @focus="$event.target.select()" :tabindex="100 + index"><!-- @keyup="cal.asistencia=cal.asistencia.toUpperCase()" -->
                                                </td>

                                                <td class="text-center" :class="(cal.resultado < 1 ? 'text-red-600' : (cal.resultado == 1 ? 'text-green-600' : ''))" data-label="Resultado" :set="(cal.puntaje >= parseInt(puntajeMinimo) ? cal.resultado = 1 : (cal.puntaje > 0 && cal.puntaje < parseInt(puntajeMinimo) ? cal.resultado = 0 : cal.resultado = 2))" :title="cal.resultado">

                                                    <span>{{ (cal.resultado == 1 ? 'Aprobado' : (cal.resultado == 2 ? 'Ausente' : 'Desaprobado')) }}</span>
                                                    <input type="hidden" v-model="cal.resultado">
                                                </td>
                                                <td v-if="canWrite" class="flex lg:table-cell" colspan="6">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>

                                                        <!-- <-- Cambiar Bimestre name -->
                                                        <BaseButton name="buttonssaveB4" color="info" :icon="mdiContentSave" small @click="updateAdmisionPuntaje(cal.id, 'actualizar', cal)" />

                                                    </BaseButtons>

                                                </td>
                                                <td data-label="Log" @click="showLog = !showLog">
                                                    <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                    <span class="text-xs" v-if="showLog">Modif. {{ cal.nombre_usuario }} {{ cal.updated_at ? formatDateTime(cal.updated_at) : '' }}</span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="flex lg:table-cell" colspan="6">
                                                    <div class="w-full flex justify-end">
                                                        <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayAdmisionPuntajes('B4')" /><!-- <-- Cambiar Bimestre -->
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <!-- <p v-else class="p-4">
                                            Aun no se inicia las calificaciones
                                        </p> -->
                            </div>

                            <div class="p-4" v-if="tabPuntaje == -1">
                                Click al bimestre para mostrar el listado ⤴
                            </div>
                        </div>

                        <!-- Informe financiero -->
                        <div v-if="mainTab == 7 && !isPsico && !isSecre" class="card-premium">
                            <div class="grid gap-3 lg:max-h-max max-h-[500px] overflow-y-auto pt-3">
                                <!-- Lista de estudiantes -->
                                <CardBox v-if="arrayDeudores.length" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <div class="w-full overflow-x-auto">
                                        <TableAdvanced modulo="cobranzas" :modulos="'Deudores ' + classroom.label" :data="arrayDeudores" :fields="arrayDeudoresCol" ruta="payementOrder" exporteable showIndex noSearch noPaginate :numberItems="50" /><!-- showTotales propiedad para PDF-->
                                    </div>
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>

                            </div>
                        </div>

                        <!-- Comnunicaciones o Anuncios -->
                        <!-- <div
                                class="bg-white tab tab-purple w-full overflow-hidden border border-purple-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="purple" type="radio"
                                    name="tabs-aula">
                                <label class="block p-4 leading-normal cursor-pointer bg-purple-100 content-center"
                                    for="purple" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-purple-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Anuncios
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-purple-600  bg-white leading-normal">
                                    <div class="p-4 grid md:grid-cols-2 xl:grid-cols-3 gap-4 lg:max-h-max max-h-[600px] overflow-y-auto ">
                                        <div class="md:col-span-2 xl:col-span-3">
                                            <BaseButton :icon="mdiPlusBox" color="info" icon-size="20" small
                                                label="Nuevo Evento" />
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <p class="p-4">
                                            Estamos construyendo su espacio de Anuncios
                                        </p>
                                    </div>
                                </div>
                            </div> -->

                        <!-- Eventos -->
                        <!-- <div
                                class="bg-white tab tab-gray w-full overflow-hidden border border-gray-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-four"
                                    type="radio" name="tabs-aula">
                                <label class="block p-4 leading-normal cursor-pointer bg-gray-100 content-center"
                                    for="tab-single-four" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-gray-600">
                                            <BaseIcon :path="mdiCalendarClock" :size="24" class="mr-3 " />
                                            Agenda / Nota diaria
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-gray-600  bg-white leading-normal">
                                    <div class="p-4 grid lg:grid-cols-2 gap-4 lg:max-h-max max-h-[600px] overflow-y-auto "> -->
                        <!-- <div class="lg:col-span-2">
                                            <BaseButton :icon="mdiPlusBox" color="info" icon-size="20" small
                                                label="Nuevo Evento" />
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div>
                                        <div class="p-2 border border-gray-200 rounded-lg">
                                            <h2 class="text-sm">08 de Abril del 2023</h2>
                                            <h1 class="text-base font-bold">Expocisión de Grupo 2 - Clase de Quimica</h1>
                                            <p class="text-xs">hace 38 minutos</p>
                                            <p><b>Nota:</b> Presentación postergada hace 1 semana</p>
                                        </div> -->
                        <!-- <div> -->

                        <!-- <BreezeLabel for="Nota diaria" value="Descripción"/> -->
                        <!-- Ref: https://vueup.github.io/vue-quill/guide/toolbar.html -->
                        <!-- <QuillEditor v-model:content="diarioCollaborator" contentType="html" toolbar="essential" theme="snow" :modules="modulesEditor" rows="10"/>

                                        </div>
                                        <div class="flex lg:table-cell" colspan="3">
                                            <div class="w-full flex justify-end">
                                                <BaseButton :icon="mdiContentSave" color="info"
                                                    icon-size="20" small label="Guardar" />
                                            </div>
                                        </div>
                                    </div> -->
                        <!-- </div>
                            </div> -->

                        <!-- Otra sección -->
                        <!-- <div
                                class="bg-white tab tab-gray w-full overflow-hidden border border-gray-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="gray" type="radio"
                                    name="tabs-aula">
                                <label class="block p-4 leading-normal cursor-pointer bg-gray-100 content-center" for="gray"
                                    style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-gray-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Mis Calificaciones
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-gray-600  bg-white leading-normal">
                                            <p class="p-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Tenetur,
                                        architecto, explicabo perferendis nostrum, maxime impedit atque odit sunt
                                        pariatur
                                        illo
                                        obcaecati soluta molestias iure facere dolorum adipisci eum? Saepe, itaque.
                                    </p>
                                </div>
                            </div> -->

                    </div>
                </div>
            </div>
        </section>

        <!-- MODAL DE CONFIGURACIÓN DE HORARIO DE CURSOS -->
        <CardBoxModal v-model="isScheduleModalOpen" title="Configuración de Horario Semanal" sizeModal="large" no-buttons hasCancel>
            <div class="space-y-4">
                <div class="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-950/30 dark:to-purple-950/20 p-4 rounded-2xl border border-indigo-100 dark:border-indigo-900/40 flex items-center justify-between flex-wrap gap-3">
                    <div class="flex items-center gap-3">
                        <div class="p-2 rounded-xl bg-indigo-600 text-white shadow-xs">
                            <Icon icon="tabler:calendar-time" class="w-5 h-5" />
                        </div>
                        <div>
                            <h5 class="text-xs font-bold text-indigo-950 dark:text-indigo-200">
                                Horario para {{ classroom.label }}
                            </h5>
                            <p class="text-[11px] text-indigo-700/80 dark:text-indigo-400">
                                Configura los turnos, asignaturas y recreos de Lunes a Viernes.
                            </p>
                        </div>
                    </div>
                    <button type="button" @click="populateStandardSchedule" class="px-3.5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold transition flex items-center gap-1.5 shadow-xs">
                        <Icon icon="tabler:wand" class="w-4 h-4" />
                        Insertar Plantilla Rápida
                    </button>
                </div>

                <!-- Formulario para agregar bloque -->
                <div class="p-4 bg-slate-50 dark:bg-slate-800/60 rounded-2xl border border-slate-200 dark:border-slate-700/80 shadow-xs">
                    <span class="text-xs font-bold text-slate-700 dark:text-slate-300 block mb-3 uppercase tracking-wider text-[11px]">
                        Agregar Nuevo Bloque de Horario
                    </span>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-3">
                        <div class="sm:col-span-1 md:col-span-2">
                            <label class="text-[11px] font-bold text-slate-600 dark:text-slate-400 block mb-1">Día</label>
                            <select v-model="scheduleForm.day_of_week" class="w-full text-xs rounded-xl border-slate-300 dark:border-slate-600 dark:bg-slate-800 py-2">
                                <option v-for="d in daysOfWeekList" :key="d.id" :value="d.id">{{ d.label }}</option>
                            </select>
                        </div>
                        <div class="sm:col-span-1 md:col-span-2">
                            <label class="text-[11px] font-bold text-slate-600 dark:text-slate-400 block mb-1">Hora Inicio</label>
                            <input type="time" v-model="scheduleForm.start_time" class="w-full text-xs rounded-xl border-slate-300 dark:border-slate-600 dark:bg-slate-800 py-2" />
                        </div>
                        <div class="sm:col-span-1 md:col-span-2">
                            <label class="text-[11px] font-bold text-slate-600 dark:text-slate-400 block mb-1">Hora Fin</label>
                            <input type="time" v-model="scheduleForm.end_time" class="w-full text-xs rounded-xl border-slate-300 dark:border-slate-600 dark:bg-slate-800 py-2" />
                        </div>
                        <div class="sm:col-span-1 md:col-span-2">
                            <label class="text-[11px] font-bold text-slate-600 dark:text-slate-400 block mb-1">Tipo</label>
                            <select v-model="scheduleForm.type" class="w-full text-xs rounded-xl border-slate-300 dark:border-slate-600 dark:bg-slate-800 py-2">
                                <option value="clase">Clase</option>
                                <option value="recreo">Recreo</option>
                            </select>
                        </div>
                        <div class="sm:col-span-2 md:col-span-3">
                            <label class="text-[11px] font-bold text-slate-600 dark:text-slate-400 block mb-1">
                                {{ scheduleForm.type === 'clase' ? 'Curso Activo' : 'Etiqueta Recreo' }}
                            </label>
                            <select v-if="scheduleForm.type === 'clase'" v-model="scheduleForm.id_course" class="w-full text-xs rounded-xl border-slate-300 dark:border-slate-600 dark:bg-slate-800 py-2 truncate">
                                <option v-for="c in scheduleCourses" :key="c.id" :value="c.id">{{ c.label }}</option>
                            </select>
                            <input v-else type="text" v-model="scheduleForm.label_break" placeholder="Ej: Recreo / Almuerzo" class="w-full text-xs rounded-xl border-slate-300 dark:border-slate-600 dark:bg-slate-800 py-2" />
                        </div>
                        <div class="sm:col-span-2 md:col-span-1 flex items-end">
                            <button type="button" @click="addScheduleItem" class="w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-bold transition flex items-center justify-center gap-1 shadow-xs h-[38px]" title="Agregar bloque">
                                <Icon icon="tabler:plus" class="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Lista de bloques creados -->
                <div>
                    <div class="flex items-center justify-between mb-2">
                        <span class="text-xs font-bold text-slate-700 dark:text-slate-300">
                            Bloques programados ({{ scheduleList.length }})
                        </span>
                        <span class="text-[11px] text-slate-400">
                            Ordenados por día y hora
                        </span>
                    </div>

                    <div class="max-h-80 overflow-y-auto space-y-2 pr-1">
                        <div v-for="(item, idx) in scheduleList" :key="idx" class="flex items-center justify-between p-3 bg-white dark:bg-slate-800/90 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700/70 transition shadow-2xs">
                            <div class="flex items-center gap-3 flex-wrap">
                                <span class="px-2.5 py-1 rounded-lg bg-indigo-50 dark:bg-indigo-950/60 text-indigo-700 dark:text-indigo-300 font-bold text-[11px] tracking-wide">
                                    {{ daysOfWeekList.find(d => d.id === item.day_of_week)?.label }}
                                </span>
                                <span class="px-2 py-0.5 rounded-md bg-slate-100 dark:bg-slate-700 font-mono text-xs text-slate-700 dark:text-slate-300 font-semibold">
                                    {{ item.start_time }} - {{ item.end_time }}
                                </span>
                                <span v-if="item.type === 'recreo'" class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-amber-50 dark:bg-amber-950/30 text-amber-700 dark:text-amber-400 font-bold text-xs border border-amber-200/60 dark:border-amber-900/40">
                                    ☕ {{ item.label_break || 'Recreo' }}
                                </span>
                                <span v-else class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-950/30 text-blue-700 dark:text-blue-300 font-bold text-xs border border-blue-200/60 dark:border-blue-900/40">
                                    📚 {{ item.course?.label || scheduleCourses.find(c => c.id === item.id_course)?.label || 'Curso' }}
                                </span>
                            </div>
                            <button type="button" @click="removeScheduleItem(idx)" class="text-slate-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/30 p-1.5 rounded-lg transition" title="Eliminar bloque">
                                <Icon icon="tabler:trash" class="w-4 h-4" />
                            </button>
                        </div>
                        <div v-if="scheduleList.length === 0" class="py-10 text-center text-xs text-slate-400 italic bg-slate-50 dark:bg-slate-800/30 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700">
                            No hay bloques configurados aún. Haz clic en "Insertar Plantilla Rápida" o agrega uno manualmente.
                        </div>
                    </div>
                </div>

                <div class="flex justify-end gap-2 pt-4 border-t border-slate-200 dark:border-slate-700">
                    <button type="button" @click="isScheduleModalOpen = false" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-bold transition">
                        Cerrar
                    </button>
                    <button type="button" @click="saveScheduleToServer" :disabled="loadingSchedule" class="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold transition disabled:opacity-50 flex items-center gap-1.5 shadow-xs">
                        <Icon v-if="loadingSchedule" icon="tabler:loader-2" class="w-4 h-4 animate-spin" />
                        <Icon v-else icon="tabler:device-floppy" class="w-4 h-4" />
                        {{ loadingSchedule ? 'Guardando...' : 'Guardar Todo el Horario' }}
                    </button>
                </div>
            </div>
        </CardBoxModal>
    </BreezeAuthenticatedLayout>
</template>